import PaymentQRDisplay from '../components/PaymentQRDisplay';
import React, { useContext, useEffect, useRef, useState } from 'react'
// import { useTranslation } from 'react-i18next';
// import Page from "../components/Page";
// import { IconPlus, IconNotes, IconArmchair, IconScreenShare, IconSearch, IconDeviceFloppy, IconChefHat, IconCash, IconMinus, IconNote, IconTrash, IconFilter, IconPhoto, IconFilterFilled, IconClipboardList, IconX, IconClearAll, IconPencil, IconCheck, IconCarrot, IconRotate, IconQrcode, IconArmchair2, IconUser, IconCategory, IconGridDots, IconLayoutGrid, IconListDetails, IconListTree, IconMenu4, IconLayoutGridFilled, IconMenu2, IconLayoutList, IconLayout2, IconLayout2Filled, IconAlertTriangleFilled } from "@tabler/icons-react";
// import { VITE_BACKEND_SOCKET_IO, iconStroke } from "../config/config";
// import { cancelAllQROrders, cancelQROrder, createOrder, createOrderAndInvoice, getDrafts, getQROrders, getQROrdersCount, initPOS, setDrafts } from "../controllers/pos.controller";
import { getCustomerLoyalty, useLoyaltySettings } from '../controllers/loyalty.controller';
// import { CURRENCIES } from '../config/currencies.config';
// import { PAYMENT_ICONS } from "../config/payment_icons";
// import { toast } from "react-hot-toast";
// import { searchCustomer } from '../controllers/customers.controller';
// import { Link, useNavigate } from 'react-router-dom';
// import { setDetailsForReceiptPrint } from '../helpers/ReceiptHelper';
// import { useSocket } from "../contexts/SocketContext";
// ;// ✅ Keep this for context
// import { getImageURL } from '../helpers/ImageHelper';
// import { getUserDetailsInLocalStorage } from '../helpers/UserDetails';
// import AsyncCreatableSelect from 'react-select/async-creatable';
// import DialogAddCustomer from '../components/DialogAddCustomer';
// import POSMenuItemDetailedView from '../components/POSMenuItemDetailedView';
// import POSMenuItemCompactView from '../components/POSMenuItemCompactView';
// import { clsx } from "clsx";
// import { useTheme } from '../contexts/ThemeContext';
import { groupItemsByPrinter, printKOT } from '../helpers/PrinterHelper';

// // ✅ CORRECT - Single import from socket utils

// export default function POSPage() {
//   const { t } = useTranslation();
//   const user = getUserDetailsInLocalStorage();
//   const { socket, isConnected, safeEmit, initSocket, getSocket, waitForConnection, disconnectSocket } = useSocket();
//   const navigate = useNavigate();
//   const { theme } = useTheme();
//   const diningOptionRef = useRef();
//   const tableRef = useRef();

//   // dialog: notes ref
//   const dialogNotesIndexRef = useRef();
//   const dialogNotesTextRef = useRef();
//   // dialog: notes ref

//   // dialog: category filter
//   const categoryFilterDropdownRef = useRef(null);
//   // dialog: category filter

//   // dialog: category filter
//   const draftTitleRef = useRef(null);
//   // dialog: category filter

//   // dialog: search customer
//   const searchCustomerRef = useRef(null);
//   // dialog: search customer

//   const tapSound = new Audio("/tap.mp3");

//   const [state, setState] = useState({
//     view:"detailed",
//     categories: [],
//     menuItems: [],
//     paymentTypes: [],
//     printSettings: null,
//     storeSettings: null,
//     storeTables: [],
//     serviceCharge:null,
//     currency: "",
//     isLoading: true,

//     cartItems: [],
//     customerType: "WALKIN",
//     customer: null,
//     addCustomerDefaultValue: null,

//     searchQuery: "",
//     selectedCategory: "all",

//     selectedItemId: null,

//     drafts: [],

//     itemsTotal: 0,
//     taxTotal: 0,
//     serviceChargeTotal:0,
//     payableTotal: 0,

//     orderId: null,
//     tokenNo: null,

//     qrOrdersCount: 0,
//     qrOrders: [],
//     selectedQrOrderItem: null,

//     selectedPaymentType: null,
//   });

// //   useEffect(()=>{
// //     _initPOS();
// //     _initSocket();
// //   },[]);

// //   const { categories, menuItems, paymentTypes, printSettings, storeSettings, storeTables, currency, cartItems, searchQuery, selectedCategory, selectedItemId, drafts, customer, customerType, isLoading } = state;

// // // GLOBAL SAFE LOADER — prevents ALL react-select crashes
// // const safeLoadOptions = (fn) => {
// //   return (input) => {
// //     return new Promise((resolve) => {
// //       setTimeout(async () => {
// //         try {
// //           const result = await fn(input);
// //           resolve(Array.isArray(result) ? result : []);
// //         } catch (err) {
// //           console.error("safeLoadOptions error:", err);
// //           resolve([]);
// //         }
// //       }, 0);
// //     });
// //   };
// // };

// //  // Import the safe functions

// // const sendNewOrderEvent = (tokenNo, orderId) => {
// //   // Use the safeEmit function from your socket utils
// //   const success = safeEmit('new_order_backend', { 
// //     tokenNo, 
// //     orderId, 
// //     tenantId: user.tenant_id 
// //   });

// //   if (!success) {
// //     console.warn('⚠️ Order event not sent via socket (will still be created in database)');
// //   }
// // }

// // const playTapSound = () => {
// //   tapSound.play();
// // }

//   useEffect(()=>{
//     _initPOS();
//     _initSocket();
//   },[]);

//   const { categories, menuItems, paymentTypes, printSettings, storeSettings, storeTables, currency, cartItems, searchQuery, selectedCategory, selectedItemId, drafts, customer, customerType, isLoading } = state;



//   const sendNewOrderEvent = (tokenNo, orderId) => {
//     if (isSocketConnected) {
//       socket.emit('new_order_backend', {tokenNo, orderId}, user.tenant_id);
//     } else {
//       // Handle disconnected state (optional)
//       initSocket();
//       socket.emit('new_order_backend', {tokenNo, orderId}, user.tenant_id);
//     }
//   }

//   const playTapSound = () => {
//     tapSound.play();
//   }


// async function _initPOS() {
//   try {
//     console.log("Starting POS initialization...");

//     const fullRes = await initPOS();
//     console.log("initPOS raw response:", fullRes);

//     // More defensive data extraction
//     const data = fullRes?.data ?? fullRes ?? {};
//     console.log("Processed POS data:", data);

//     // Validate critical data structures
//     if (!data || typeof data !== 'object') {
//       throw new Error('Invalid POS data structure received');
//     }

//     const {
//       categories = [],
//       menuItems = [],
//       paymentTypes = [],
//       printSettings = null,
//       storeSettings = null,
//       storeTables = [],
//       serviceCharge = null,
//     } = data;

//     // Validate storeSettings exists before accessing currency
//     if (!storeSettings || typeof storeSettings !== 'object') {
//       console.warn('storeSettings is missing or invalid');
//     }

//     const currencySymbol = storeSettings?.currency
//       ? CURRENCIES.find(c => c.cc === storeSettings.currency)?.symbol || ""
//       : "";

//     let totalQROrders = 0;
//     try {
//       const qrRes = await getQROrdersCount();
//       totalQROrders = qrRes?.data?.totalQROrders ?? 0;
//     } catch (qrError) {
//       console.warn('Failed to fetch QR orders count:', qrError);
//     }

//     setState(prev => ({
//       ...prev,
//       categories: Array.isArray(categories) ? categories : [],
//       menuItems: Array.isArray(menuItems) ? menuItems : [],
//       paymentTypes: Array.isArray(paymentTypes) ? paymentTypes : [],
//       printSettings: printSettings || null,
//       storeSettings: storeSettings || null,
//       storeTables: Array.isArray(storeTables) ? storeTables : [],
//       serviceCharge: serviceCharge || null,
//       currency: currencySymbol,
//       qrOrdersCount: totalQROrders,
//       isLoading: false,
//     }));

//   } catch (error) {
//     console.error("POS init failed:", error);

//     // Set default empty state to prevent further errors
//     setState(prev => ({
//       ...prev,
//       categories: [],
//       menuItems: [],
//       paymentTypes: [],
//       printSettings: null,
//       storeSettings: null,
//       storeTables: [],
//       serviceCharge: null,
//       currency: "",
//       qrOrdersCount: 0,
//       isLoading: false,
//     }));

//     toast.error("Failed to load POS data. Please refresh the page.");
//   }
// }

//   const _getQROrdersCount = async () => {
//     try {
//       const res = await getQROrdersCount();
//       if(res.status == 200) {
//         const data = res.data;

//         return data?.totalQROrders || 0;
//       }
//     } catch (error) {
//       console.error(error);
//       throw error;
//     }
//   }
//   const _initSocket = async () => {
//   try {
//     // Ensure socket is initialized (idempotent — will reuse if already connected)
//     initSocket();

//     // Wait up to 8s for socket to connect
//     try {
//       await waitForConnection(8000);
//     } catch (err) {
//       console.warn("⚠️ Socket connection timeout:", err?.message || err);
//     }

//     // Get the live socket instance
//     const s = getSocket();
//     if (!s || !s.connected) {
//       console.warn("⚠️ Socket not connected, skipping listener setup.");
//       return;
//     }

//     // Remove old listener if it exists (prevents duplication)
//     s.off("new_qrorder");

//     // Authenticate once connected
//     await safeEmit("authenticate", user.tenant_id, { wait: true, timeout: 5000 });
//     console.log("✅ Socket authenticated for tenant:", user.tenant_id);

//     // Listen for new QR orders
//     s.on("new_qrorder", async (payload) => {
//       console.log("📥 Received new_qrorder:", payload);
//       try {
//         const totalQROrders = await _getQROrdersCount();
//         setState((prevState) => ({
//           ...prevState,
//           qrOrdersCount: totalQROrders || 0,
//         }));
//       } catch (error) {
//         console.error("new_qrorder handler error:", error);
//       }
//     });

//     console.log("✅ Socket listener attached successfully.");
//   } catch (err) {
//     console.error("❌ _initSocket failed:", err);
//   }
// };


//   if(isLoading) {
//     return <Page className='px-4 py-3 flex flex-col min-h-0'>
//       <div className='mt-4 h-[calc(100vh-136px)] flex gap-4 skeleton'>
//         <div className='border border-restro-border-green-light rounded-2xl h-full w-[70%] overflow-y-auto'></div>
//         <div className='border border-restro-border-green-light rounded-2xl h-full w-[30%] relative flex flex-col'></div>
//       </div>
//     </Page>
//   }


//   // cart
//   function canPrepareMenuItem(menuItem, quantity = 1, selectedVariantId = null, selectedAddonIds = []) {
//     const usageMap = {};

//     menuItem.recipeItems.forEach((recipe) => {
//       const appliesToBase = recipe.variant_id === 0 && recipe.addon_id === 0;
//       const appliesToVariant = recipe.variant_id > 0 && recipe.variant_id == selectedVariantId;
//       const appliesToAddon = recipe.addon_id > 0 && selectedAddonIds.includes(recipe.addon_id.toString());

//       if (appliesToBase || appliesToVariant || appliesToAddon) {
//         const invId = recipe.inventory_item_id;
//         const requiredQty = parseFloat(String(String(recipe.recipe_quantity).replace(/,/g, "")).replace(/,/g, "")) * quantity;

//         if (!usageMap[invId]) {
//           usageMap[invId] = {
//             ingredient_title: recipe.ingredient_title,
//             total_required: 0,
//             current_quantity: parseFloat(String(String(recipe.current_quantity || 0).replace(/,/g, "")).replace(/,/g, "")),
//           };
//         }

//         usageMap[invId].total_required += requiredQty;
//       }
//     });

//     for (const invId in usageMap) {
//       const { ingredient_title, total_required, current_quantity } = usageMap[invId];
//       if (current_quantity < total_required) {
//         console.warn(
//           `Cannot prepare '${menuItem.title}' - Ingredient '${ingredient_title}' is insufficient`
//         );
//         return false;
//       }
//     }

//     return true;
//   }

//   function addItemToCart(item) {
//     const modifiedItem = {
//       ...item,
//       quantity: 1,
//       notes: null
//     }

//     if (!canPrepareMenuItem(item, 1)) {
//       toast.error(t('inventory.insufficient_stock_message_pos'));
//       return;
//     }

//     if(!cartItems) {
//       setState({
//         ...state,
//         cartItems: [modifiedItem]
//       })
//       return;
//     }
//     setState({
//       ...state,
//       cartItems: [...cartItems, modifiedItem]
//     })
//     playTapSound();
//   }

//   function removeItemFromCart(index) {
//     setState({
//       ...state,
//       cartItems: cartItems.filter((c,i)=> i !== index)
//     })
//     playTapSound();
//   }

//   function addCartItemQuantity(index, currentQuantity) {
//     const newQuantity = currentQuantity + 1;
//     const newCartItems = cartItems;

//     if (!canPrepareMenuItem(newCartItems[index], newQuantity, newCartItems[index].variant_id, newCartItems[index].addons_ids)) {
//       toast.error(t('inventory.insufficient_stock_message_pos'));
//       return;
//     }

//     newCartItems[index].quantity = newQuantity;

//     setState({
//       ...state,
//       cartItems: [...newCartItems]
//     });
//     playTapSound();
//   }
//   function minusCartItemQuantity(index, currentQuantity) {
//     const newQuantity = currentQuantity - 1;
//     let newCartItems = cartItems;

//     newCartItems[index].quantity = newQuantity;

//     if(newQuantity == 0) {
//       newCartItems = cartItems.filter((v, i)=>i!=index);
//     }

//     setState({
//       ...state,
//       cartItems: [...newCartItems]
//     });
//     playTapSound();
//   }
//   // cart

//   // order notes
//   const btnOpenNotesModal = (index, notes) => {
//     dialogNotesIndexRef.current.value = index;
//     dialogNotesTextRef.current.value = notes;
//     document.getElementById('modal-notes').showModal()
//   }
//   const btnAddNotes = () => {
//     const index = dialogNotesIndexRef.current.value;
//     const notes = dialogNotesTextRef.current.value || null;

//     const newCartItems = cartItems;
//     newCartItems[index].notes = notes;

//     setState({
//       ...state,
//       cartItems: newCartItems
//     })
//   };
//   // order notes

//   // category filter modal
//   const btnOpenCategoryFilterModal = () => {
//     categoryFilterDropdownRef.current.value = selectedCategory;
//     document.getElementById('modal-categories').showModal()
//   }
//   const btnApplyCategoryFilter = () => {
//     const selectedCategoryFromDropdown = categoryFilterDropdownRef.current.value || "";
//     setState({
//       ...state,
//       selectedCategory: selectedCategoryFromDropdown
//     })
//   }
//   const btnClearSelectedCategory = () => {
//     setState({
//       ...state,
//       selectedCategory: "all"
//     })
//   };
//   // category filter modal

//   // variant, addon modal

//   const resetVariantsAndAddons = () => {
//     const itemVariants = document.getElementsByName("variants");
//     itemVariants.forEach((item, index) => {
//       item.checked = index === 0;
//     });

//     const itemAddons = document.getElementsByName("addons");
//     itemAddons.forEach((item) => {
//       item.checked = false;
//     });
//   };

//   const btnOpenVariantAndAddonModal = (menuItemId) => {

//     resetVariantsAndAddons();

//     setState({
//       ...state,
//       selectedItemId: menuItemId
//     })
//     document.getElementById('modal-variants-addons').showModal()
//   }
//   const btnAddMenuItemToCartWithVariantsAndAddon = () => {
//     let price = 0;
//     let selectedVariantId = null;
//     const selectedAddonsId = [];

//     const itemVariants = document.getElementsByName("variants");
//     itemVariants.forEach((item)=>{
//       if(item.checked) {
//         selectedVariantId = item.value;
//         return;
//       }
//     })

//     const itemAddons = document.getElementsByName("addons");
//     itemAddons.forEach((item)=>{
//       if(item.checked) {
//         selectedAddonsId.push(item.value);
//       }
//     })

//     // get selected menu item
//     const selectedItem = menuItems.find((item)=>item.id == selectedItemId);

//     const addons = selectedItem?.addons || [];
//     const variants = selectedItem?.variants || [];

//     let selectedVariant = null;
//     if(selectedVariantId) {
//       selectedVariant = variants.find((v)=>v.id == selectedVariantId);
//       price = parseFloat(String(String(selectedVariant.price).replace(/,/g, "")).replace(/,/g, ""));
//     } else {
//       price = parseFloat(String(String(selectedVariant?.price ?? selectedItem.price).replace(/,/g, "")).replace(/,/g, ""))
//     }

//     let selectedAddons = [];
//     if(selectedAddonsId.length > 0) {
//       selectedAddons = selectedAddonsId.map((addonId)=>addons.find((addon)=>addon.id == addonId))
//       selectedAddons.forEach((addon)=>{
//         const addonPrice = parseFloat(String(String(addon.price).replace(/,/g, "")).replace(/,/g, ""));
//         price = price + addonPrice
//       });
//     }

//     const canPrepare = canPrepareMenuItem(selectedItem, 1/**quantity */, selectedVariantId, selectedAddonsId);

//     if (!canPrepare) {
//       toast.error(t('inventory.insufficient_stock_message_pos'));
//       return;
//     }

//     const itemCart = {...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons}
//     addItemToCart(itemCart)
//   };
//   // variant, addon modal

//   // drafts
//   const btnOpenSaveDraftModal = () => {
//     if(cartItems.length == 0) {
//       toast.error(t('pos.empty_cart'));
//       return;
//     }
//     document.getElementById('modal-save-draft').showModal()
//   }
//   const btnAddtoDrafts = () => {
//     const drafts = getDrafts();

//     const nameRef = draftTitleRef.current.value || "";
//     const date = new Date().toLocaleString();

//     const draftItem = {
//       nameRef: nameRef,
//       date,
//       cart: cartItems
//     };

//     drafts.push(draftItem);

//     setDrafts(drafts);
//     setState({
//       ...state,
//       cartItems: []
//     })
//   };

//   const btnInitNewOrder = () => {
//     setState({
//       ...state,
//       cartItems: [],
//       customer: null,
//       customerType: "WALKIN",
//       selectedQrOrderItem: null,
//     })
//     playTapSound();
//   }

//   const btnOpenDraftsModal = () => {
//     const drafts = getDrafts();
//     setState({
//       ...state,
//       drafts: [...drafts]
//     });
//     document.getElementById("modal-drafts").showModal();
//   }

//   const btnDeleteDraftItem = index => {
//     const drafts = getDrafts();
//     const newDrafts = drafts.filter((v,i)=>i!=index);

//     setDrafts(newDrafts);

//     setState({
//       ...state,
//       drafts: [...newDrafts]
//     });
//   };

//   const btnClearDrafts = () => {
//     setDrafts([]);
//     setState({
//       ...state,
//       drafts: []
//     });
//   };
//   const btnSelectDraftItemToCart = draftItem => {
//     const {nameRef, date, cart} = draftItem;

//     setState({
//       ...state,
//       cartItems: [...cart]
//     });

//     document.getElementById("modal-drafts").close();
//   };
//   // drafts

//   // QR Menu Orders
//   const btnShowQROrdersModal = async () => {
//     try {
//       const res = await getQROrders();
//       if(res.status == 200) {
//         const data = res.data;
//         setState({
//           ...state,
//           qrOrders: [...data]
//         })
//         document.getElementById("modal-qrorders").showModal();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const btnClearQROrders = async () => {
//     const isConfirm = window.confirm(t('pos.delete_confirm'));
//     if(!isConfirm) {
//       return;
//     }
//     try {
//       toast.loading(t('pos.please_wait'));
//       const res = await cancelAllQROrders();
//       if(res.status == 200) {
//         toast.dismiss();
//         toast.success(res.data.message);
//         setState((prevState)=>({
//           ...prevState, qrOrders: [], qrOrdersCount: 0,
//         }))
//         playTapSound();
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.getting_issues');
//       console.log(error);
//       toast.dismiss();
//       toast.error(message);
//     }
//   }
//   const btnCancelQROrder = async (orderId) => {
//     const isConfirm = window.confirm(t('pos.delete_confirm'));
//     if(!isConfirm) {
//       return;
//     }
//     try {
//       toast.loading(t('pos.please_wait'));
//       const res = await cancelQROrder(orderId);
//       if(res.status == 200) {
//         toast.dismiss();
//         toast.success(res.data.message);

//         const newQROrders = state.qrOrders.filter((item)=>item.id != orderId);
//         const newQROrderItem = state.qrOrdersCount - 1;

//         setState((prevState)=>({
//           ...prevState, qrOrders: [...newQROrders], qrOrdersCount: newQROrderItem,
//         }))
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.getting_issues');
//       console.log(error);
//       toast.dismiss();
//       toast.error(message);
//     }
//   }
//   const btnSelectQROrder = (qrOrder) => {
//     console.log(qrOrder);

//     if(qrOrder.table_id) {
//       tableRef.current.value = qrOrder.table_id;
//     }

//     // const itemCart = {...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons}

//     const modifiedCart = qrOrder.items.map((item)=>{
//       const id = item.item_id;

//       let selectedVariant = {
//         id: item.variant_id,
//         item_id: id,
//         price: item.variant_price,
//         title: item.variant_title,
//       }

//       return {
//         ...item,
//         id: id,
//         title: item.item_title,
//         addons_ids: item?.addons?.map((i)=>i.id),
//         variant: selectedVariant || null,
//         variant_id: item.variant_id || null,
//       }
//     })

//     setState({
//       ...state,
//       cartItems: modifiedCart,
//       selectedQrOrderItem: qrOrder.id,
//       customerType: qrOrder.customer_type,
//       customer: {phone: qrOrder.customer_id, name: qrOrder.customer_name},
//     })
//     playTapSound();

//     document.getElementById('modal-qrorders').close();
//   };
//   // QR MEnu Orders

//   // search customer modal
//   const btnOpenSearchCustomerModal = () => {
//     document.getElementById("modal-search-customer").showModal();
//   };
//   const btnClearSearchCustomer = () => {
//     setState({
//       ...state,
//       customerType: "WALKIN",
//       customer: null
//     })
//   }
//   const btnSearchCustomer = async () => {
//     const phone = searchCustomerRef.current.value;

//     if(!phone) {
//       toast.error(t('pos.please_provide_phone'));
//       return;
//     }

//     try {
//       toast.loading(t('pos.please_wait'));
//       const resp = await searchCustomer(phone);
//       toast.dismiss();
//       if(resp.status == 200) {
//         setState({
//           ...state,
//           customer: resp.data,
//           customerType: "CUSTOMER"
//         })
//         document.getElementById("modal-search-customer").close()
//       }

//     } catch (error) {
//       console.log(error);
//       const message = error.response.data.message || t('pos.error_getting_details');
//       toast.dismiss();
//       toast.error(message);
//     }
//   }
//   // search customer modal


//   // send to kitchen modal
//   const calculateOrderSummary = () => {
//     let itemsTotal = 0; // without tax - net amount
//     let taxTotal = 0;
//     let serviceChargeTotal = 0;
//     let payableTotal = 0;

//     cartItems.forEach((item)=>{
//       const taxId = item.tax_id;
//       const taxTitle = item.tax_title;
//       const taxRate = Number(String(String(item.tax_rate).replace(/,/g, "")).replace(/,/g, ""));
//       const taxType = item.tax_type; // inclusive or exclusive or NULL

//       const itemPrice = Number(String(String(item.price).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(item.quantity).replace(/,/g, "")).replace(/,/g, ""));

//       if (taxType == "exclusive") {
//         const tax = (itemPrice * taxRate) / 100;
//         const priceWithTax = itemPrice + tax;

//         taxTotal += tax;
//         itemsTotal += itemPrice;
//         payableTotal += priceWithTax;
//       } else if (taxType == "inclusive") {
//         const tax = itemPrice - (itemPrice * (100 / (100 + taxRate)));
//         const priceWithoutTax = itemPrice - tax;

//         taxTotal += tax;
//         itemsTotal += priceWithoutTax;
//         payableTotal += itemPrice;
//       } else {
//         itemsTotal += itemPrice;
//         payableTotal += itemPrice;
//       }
//     });

//     // Calculate Total Service charge % from items total
//     if (state.serviceCharge) {
//       let serviceCharge = (Number(String(String(itemsTotal).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(state.serviceCharge).replace(/,/g, "")).replace(/,/g, ""))) / 100;
//       serviceChargeTotal += serviceCharge;
//       payableTotal += serviceCharge;
//     }

//     return {
//       itemsTotal, taxTotal, serviceChargeTotal, payableTotal
//     }
//   };
//   const btnShowPayAndSendToKitchenModal = () => {
//     // calculate the item - total, tax, incl. tax, excl. tax, tax total, payable total

//     if(cartItems?.length == 0) {
//       toast.error(t('pos.empty_cart'));
//       return;
//     }

//     const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal } = calculateOrderSummary();

//     setState({
//       ...state,
//       itemsTotal,
//       taxTotal,
//       serviceChargeTotal,
//       payableTotal
//     });
//     document.getElementById('modal-pay-and-send-kitchen-summary').showModal();
//   }
//   const btnPayAndSendToKitchen = async () => {
//     if(!state.selectedPaymentType) {
//       return toast.error(t('orders.select_payment_method'));
//     }
//     try {
//       const deliveryType = diningOptionRef.current.value;
//       const tableId = tableRef.current.value;
//       const customerType = state.customerType;
//       const customer = state.customer;

//       toast.loading(t('pos.please_wait'));
//       const res = await createOrderAndInvoice(cartItems, deliveryType, customerType, customer, tableId, state.itemsTotal, state.taxTotal, state.serviceChargeTotal , state.payableTotal, state.selectedQrOrderItem, state.selectedPaymentType);
//       toast.dismiss();
//       if(res.status == 200) {
//         const data = res.data;
//         toast.success(res.data.message);
//         document.getElementById("modal-pay-and-send-kitchen-summary").close();

//         const page_format = printSettings?.page_format || null;
//         const is_enable_print = printSettings?.is_enable_print || 0;

//         const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v)=>v.id == state.selectedPaymentType);
//         let paymentMethodText;
//         if(paymentType) {
//           paymentMethodText = paymentType.title;
//         }

//         setDetailsForReceiptPrint({
//           cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
//           itemsTotal: state.itemsTotal,
//           taxTotal: state.taxTotal,
//           serviceChargeTotal:state.serviceChargeTotal,
//           payableTotal: state.payableTotal,
//           tokenNo: data.tokenNo,
//           orderId: data.orderId,
//           paymentMethod: paymentMethodText
//         });

//         sendNewOrderEvent(data.tokenNo, data.orderId);

//         let newQROrderItemCount = state.qrOrdersCount;
//         let newQROrders = [];
//         if(state.selectedQrOrderItem) {
//           newQROrderItemCount -= 1;
//           newQROrders = state?.qrOrders?.filter((item)=>item.id != state.selectedQrOrderItem);
//         }

//         setState((prev) => ({
//           ...prev,
//           cartItems: [],
//           tokenNo: data.tokenNo,
//           orderId: data.orderId,
//           selectedQrOrderItem: null,
//           qrOrders: newQROrders,
//           qrOrdersCount: newQROrderItemCount,
//           selectedPaymentType: null,
//         }))

//         _initPOS()

//         if(is_enable_print) {
//           setTimeout(()=>{
//             const receiptWindow = window.open("/print-receipt", "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
//             receiptWindow.onload = (e) => {
//               setTimeout(()=>{
//                 receiptWindow.print();
//               },800)
//             }
//           }, 100)
//           return;
//         }

//         // show print token dialog
//         document.getElementById("modal-print-token").showModal();
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.something_went_wrong');
//       console.error(error);

//       toast.dismiss();
//       toast.error(message);
//     }
//   };

//   const btnShowSendToKitchenModal = () => {
//     // calculate the item - total, tax, incl. tax, excl. tax, tax total, payable total

//     if(cartItems?.length == 0) {
//       toast.error(t('pos.empty_cart'));
//       return;
//     }

//     const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal } = calculateOrderSummary();

//     setState({
//       ...state,
//       itemsTotal,
//       taxTotal,
//       serviceChargeTotal,
//       payableTotal
//     });
//     document.getElementById('modal-send-kitchen-summary').showModal();
//   }

//   const btnSendToKitchen = async () => {
//     try {
//       const deliveryType = diningOptionRef.current.value;
//       const tableId = tableRef.current.value;
//       const customerType = state.customerType;
//       const customer = state.customer;

//       toast.loading(t('pos.please_wait'));
//       const res = await createOrder(cartItems, deliveryType, customerType, customer, tableId, state.selectedQrOrderItem);
//       toast.dismiss();
//       if(res.status == 200) {
//         const data = res.data;
//         toast.success(res.data.message);
//         document.getElementById("modal-send-kitchen-summary").close();

//         const page_format = printSettings?.page_format || null;
//         const is_enable_print = printSettings?.is_enable_print || 0;

//         setDetailsForReceiptPrint({
//           cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
//           itemsTotal: state.itemsTotal,
//           taxTotal: state.taxTotal,
//           serviceChargeTotal:state.serviceChargeTotal,
//           payableTotal: state.payableTotal,
//           tokenNo: data.tokenNo,
//           orderId: data.orderId
//         });

//         sendNewOrderEvent(data.tokenNo, data.orderId);

//         let newQROrderItemCount = state.qrOrdersCount;
//         let newQROrders = [];
//         if(state.selectedQrOrderItem) {
//           newQROrderItemCount -= 1;
//           newQROrders = state?.qrOrders?.filter((item)=>item.id != state.selectedQrOrderItem);
//         }

//         setState((prev) => ({
//           ...prev,
//           cartItems: [],
//           tokenNo: data.tokenNo,
//           orderId: data.orderId,
//           selectedQrOrderItem: null,
//           qrOrders: newQROrders,
//           qrOrdersCount: newQROrderItemCount
//         }))

//         _initPOS()

//         if(is_enable_print) {
//           setTimeout(()=>{
//             const receiptWindow = window.open("/print-receipt", "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
//             receiptWindow.onload = (e) => {
//               setTimeout(()=>{
//                 receiptWindow.print();
//               },800)
//             }
//           }, 100)
//           return;
//         }

//         // show print token dialog
//         document.getElementById("modal-print-token").showModal();
//       }
//     } catch (error) {
//       const message = error?.response?.data?.message || t('pos.something_went_wrong');
//       console.error(error);

//       toast.dismiss();
//       toast.error(message);
//     }
//   };
//   const btnPrintTokenOnly = () => {
//     const tokenWindow = window.open("/print-token", "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400");
//     tokenWindow.onload = (e) => {
//       setTimeout(()=>{
//         tokenWindow.print();
//       }, 400)
//     }
//     return;
//   };
//   // send to kitchen modal


//   const setCustomer = (customer) => {

//     if(customer) {
//       setState({
//         ...state,
//         customer: {phone: customer.value, name:customer.label},
//         customerType: "CUSTOMER"
//       })
//       document.getElementById("modal-search-customer").close()
//     } else {
//       btnClearSearchCustomer();
//     }
//   }

// const searchCustomersAsync = (inputValue) => {
//   // Return a promise that ALWAYS resolves to an array
//   return new Promise((resolve) => {
//     // 1. Immediately validate
//     if (!inputValue || inputValue.trim() === '') {
//       resolve([]);
//       return;
//     }

//     const term = inputValue.trim();

//     // 2. Wrap everything in try/catch + setTimeout to avoid sync errors
//     setTimeout(async () => {
//       try {
//         const resp = await searchCustomer(term);

//         // 3. Validate response
//         if (!resp || resp.status !== 200 || !Array.isArray(resp.data)) {
//           resolve([]);
//           return;
//         }

//         // 4. Safely map
//         const options = resp.data
//           .filter(c => c && typeof c === 'object' && c.phone && c.name)
//           .map(c => ({
//             label: `${c.name} - (${c.phone})`,
//             value: c.phone,
//           }));

//         resolve(options);
//       } catch (error) {
//         console.error("searchCustomersAsync CRITICAL ERROR:", error);
//         resolve([]); // NEVER REJECT
//       }
//     }, 0);
//   });
// };
//   // search customer modal


//   return (
//     <Page className='px-4 py-3 flex flex-col min-h-0'>
//       <div className="flex md:items-center justify-between flex-col md:flex-row gap-2">
//         <h3>{t('pos.title')}</h3>
//         <div className='flex flex-wrap items-center gap-4'>
//           <button onClick={btnInitNewOrder} className = "text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconPlus size={18} stroke={iconStroke}  /> {t('pos.new_order')}
//           </button>

//           {/* QR Menu Orders */}
//           <button
//           onClick={btnShowQROrdersModal}
//           className = "relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconQrcode size={18} stroke={iconStroke}  /> {t('pos.qr_menu_orders')}

//             {state.qrOrdersCount > 0 && <div className='absolute -top-2 -right-2 w-4 h-4 rounded-full bg-red-500 text-white text-xs flex items-center justify-center'> {state.qrOrdersCount}
//             </div>}
//           </button>
//           {/* QR Menu Orders */}

//           <button onClick={btnOpenDraftsModal} className = "relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconNotes size={18} stroke={iconStroke}  /> {t('pos.drafts_list')}
//           </button>

//           <Link to="/dashboard/orders" className = "relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
//             <IconArmchair size={18} stroke={iconStroke} /> {t('pos.table_orders')}
//           </Link>
//         </div>
//       </div>

//       <div className='mt-4 md:h-[calc(100vh-136px)] flex flex-col-reverse md:flex-row gap-4'>

//         {/* pos items */}
//         <div className = "h-full md:w-[70%] overflow-y-auto scrollbar-none border rounded-2xl border-restro-border-green">
//           {/* categories, search, toggle View*/}
//          <div className="bg-background flex gap-2 justify-between sticky top-0 w-full z-10 px-4 py-3 rounded-t-2xl">
//             <div className="flex overflow-x-auto space-x-2 text-sm custom-scroll-wrapper scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
//               <div className="flex overflow-x-auto space-x-2 text-sm scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
//                 <button
//                   className={`min-w-28 px-4 py-2 rounded-xl ${selectedCategory === "all"  ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme=== 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
//                   onClick={() => {
//                     setState({
//                       ...state,
//                       selectedCategory: 'all'
//                     })
//                   }}
//                 >
//                   {t('pos.all')}
//                 </button>
//                 {categories.filter((category) => category.is_enabled).map((category, index) => (
//                 <button
//                     key={index}
//                     className={`min-w-fit px-4 py-2 rounded-xl ${selectedCategory === category.id  ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme=== 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
//                     onClick={() => {
//                       setState({
//                         ...state,
//                         selectedCategory: category.id
//                       })
//                     }}
//                   >
//                     {category.title}
//                 </button>
//                 ))}
//               </div>
//             </div>
//             <div className="flex items-center gap-2">
//               <label className="flex items-center w-60 rounded-xl px-3 py-2 gap-2 bg-restro-gray border border-restro-border-green">
//                 <IconSearch size={18} stroke={iconStroke} /> 
//                  <input value={searchQuery} onChange={e=>setState({...state, searchQuery: e.target.value})} type="search" placeholder={t('appbar.search_placeholder')} className='w-full bg-transparent outline-none' />
//               </label>
//               <button
//               className={clsx(`px-3 py-2 rounded-xl`,
//                 theme === "black" ? state.view === "compact" ? "text-restro-green bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : "text-gray-300 bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : state.view === "compact" ? "text-restro-green bg-gray-100  hover:bg-gray-200" : "text-gray-400 bg-gray-100  hover:bg-gray-200"
// )}
//               onClick={() => {
//                 const newView = state.view === 'detailed' ? 'compact' : 'detailed';
//                 setState((prev) => ({
//                   ...prev,
//                   view: newView
//                 }));
//                 sessionStorage.setItem('view', newView);
//               }}>
//                 <IconLayout2 size={24} stroke={2}/>
//               </button>
//             </div>
//           </div>
//           {/* categories, search */}


//           {/* list */}
//           <div className='flex-1 h-full pt-3'>
//           {state.view == 'detailed' ?
//             <POSMenuItemDetailedView
//               menuItems={menuItems}
//               selectedCategory={selectedCategory}
//               categories={categories}
//               searchQuery={searchQuery}
//               currency={currency}
//               btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
//               addItemToCart={addItemToCart}
//             />:
//             <POSMenuItemCompactView
//               menuItems={menuItems}
//               selectedCategory={selectedCategory}
//               categories={categories}
//               searchQuery={searchQuery}
//               currency={currency}
//               btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
//               addItemToCart={addItemToCart}
//             />
//           }
//           </div>
//           {/* list */}


//         </div>
//         {/* pos items */}

//         {/* cart */}
//         <div className = "flex flex-col h-full md:w-[30%] relative border rounded-2xl border-restro-border-green">

//           <div className = "sticky w-full px-4 py-3 border-b rounded-t-2xl border-restro-border-green">
//             {/* search customer */}
//             <div onClick={btnOpenSearchCustomerModal} className="flex items-center gap-2">
//               <input value={customerType=="WALKIN"?t('pos.walkin_customer'):`${customer.name}`} type="text" placeholder={t('pos.search_customer')} className= "flex items-center gap-1 text-sm w-full px-4 py-2 transition active:scale-95 hover:shadow-lg border rounded-lg bg-restro-gray border-restro-border-green hover:bg-restro-button-hover outline-restro-border-green"/>
//               <button onClick={btnOpenSearchCustomerModal} className = "flex items-center justify-center w-9 h-9 transition active:scale-95 rounded-lg hover:shadow-lg bg-restro-gray border border-restro-border-green hover:bg-restro-button-hover">
//                 <IconSearch size={18} stroke={iconStroke} />
//               </button>
//             </div>
//             {/* search customer */}

//             {/* delivery type */}
//             <select ref={diningOptionRef} className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green">
//               <option value="">{t('pos.select_dining_option')}</option>
//               <option value="dinein">{t('pos.dinein')}</option>
//               <option value="delivery">{t('pos.delivery')}</option>
//               <option value="takeaway">{t('pos.takeaway')}</option>
//             </select>
//             {/* delivery type */}

//             {/* table selection */}
//             <select ref={tableRef} className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green">
//               <option value="">{t('pos.select_table')}</option>
//               {
//                 storeTables.map((table, index)=>{
//                   return <option value={table.id} key={index}>{table.table_title} ({table.seating_capacity} {t('pos.person')}) - {table.floor}</option>
//                 })
//               }
//             </select>
//             {/* table selection */}
//           </div>


//           {/* items */}
//           <div className='flex-1 flex flex-col gap-4 overflow-y-auto px-4 pb-36'>
//             <div className="h-1"></div>
//             {cartItems?.map((cartItem, i)=>{
//               const {quantity, notes, title, price, variant, addons} = cartItem;
//               const itemTotal = price * quantity;
//               return <div key={i} className="text-sm rounded-lg p-2 relative border border-restro-border-green">
//                 <p>#{i+1} {title} x {quantity}</p>
//                 <p className='mt-1'>{currency}{Number(String(String(price).replace(/,/g, "")).replace(/,/g, "")).toFixed(2)} <span className='text-xs'>x {quantity}</span> <span className='font-bold'>= {currency}{itemTotal.toFixed(2)}</span></p>
//                 {notes && <p className="mt-1 text-xs text-gray-400">
//                   {t('pos.notes')}: {notes}
//                 </p>
//                 }

//                 {variant && <p className="mt-1 text-xs text-gray-400">{t('pos.variant')}: {variant.title}</p>}
//                 {(addons && addons?.length > 0 ) && <p className="mt-1 text-xs text-gray-400">{t('pos.addons')}: {addons?.map((addon)=>(`${addon?.title}`)).filter(Boolean)?.join(", ")}</p>}

//                 <div className="flex items-center justify-between gap-2 w-full mt-4">
//                   <div className='flex items-center gap-2'>
//                     <button onClick={()=>{
//                       minusCartItemQuantity(i, quantity);
//                     }} className="btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover">
//                       <IconMinus stroke={iconStroke} size={18} />
//                     </button>
//                     <div className='w-8 h-8 flex items-center justify-center font-semibold'>
//                       {quantity}
//                     </div>
//                     <button onClick={()=>{
//                       addCartItemQuantity(i, quantity);
//                     }} className = "btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover">
//                       <IconPlus stroke={iconStroke} size={18} />
//                     </button>
//                   </div>
//                   <div>
//                     <button onClick={()=>{btnOpenNotesModal(i, notes)}} className = "flex items-center text-sm transition active:scale-95 hover:shadow-lg  px-2 py-1 gap-1 rounded-lg border border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
//                       <div><IconNote size={18} stroke={iconStroke}  /></div> <p>{t('pos.add_notes')}</p>
//                     </button>
//                   </div>
//                 </div>

//                 {/* action btn delete */}
//                 <button onClick={()=>{
//                   removeItemFromCart(i);
//                 }} className = "flex items-center justify-center absolute right-2 top-2 text-restro-red rounded-full w-6 h-6 transition bg-restro-gray hover:bg-restro-button-hover ">
//                   <IconTrash stroke={iconStroke} size={14} />
//                 </button>
//                 {/* action btn delete */}
//               </div>
//             })}
//           </div>
//           {/* items */}



//           {/* actions */}
//           <div className = "absolute w-full bottom-0 pb-4 rounded-b-2xl px-4 backdrop-blur border border-t border-b-0 border-l-0 border-r-0 border-restro-border-green">
//             <div className="flex items-center flex-col lg:flex-row gap-2 mt-4">
//               <button onClick={btnOpenSaveDraftModal} className = "flex items-center flex-1 lg:flex-none text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
//                 <IconDeviceFloppy size={18} stroke={iconStroke}  /> {t('pos.draft')}
//               </button>

//               <button onClick={btnShowSendToKitchenModal} className = "flex-1 flex justify-center items-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2  gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
//                 <div><IconChefHat size={18} stroke={iconStroke}  /></div> <p>{t('pos.send_to_kitchen')}</p>
//               </button>
//             </div>
//             <div className="mt-2">
//               <button onClick={btnShowPayAndSendToKitchenModal} className="flex items-center justify-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 w-full gap-1 text-white border rounded-lg border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover">
//                 <div><IconCash size={18} stroke={iconStroke}  /></div> <p>{t('pos.create_receipt_pay')}</p>
//               </button>
//             </div>
//           </div>
//           {/* actions */}

//         </div>
//         {/* cart */}

//       </div>


//       {/* dialog: notes */}
//       <dialog id="modal-notes" className="modal modal-bottom sm:modal-middle">
//         <div className = "modal-box border border-restro-border-green dark:rounded-2xl">
//           <div className='flex justify-between items-center'>
//             <h3 className="font-bold text-lg">{t('pos.add_notes')}</h3>
//             <button className = "text-restro-red p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover" onClick={() => document.getElementById('modal-notes').close()}><IconX size={18} stroke={iconStroke}/></button>
//           </div>

//           <div className="my-4">
//             <input type="hidden" ref={dialogNotesIndexRef} />
//             <label htmlFor="dialogNotesText" className="mb-1 block text-gray-500 text-sm">{t('pos.notes')} <span className="text-xs text-gray-500">({t('pos.100_max_characters')})</span></label>
//             <input ref={dialogNotesTextRef} type="text" name="dialogNotesText" id='dialogNotesText' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.notes_placeholder')}/>
//           </div>

//           <div className="modal-action">
//             <form method="dialog" className='w-full'>
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={()=>{btnAddNotes();}} className='rounded-xl transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: notes */}

//       {/* dialog: category selection */}
//       <dialog id="modal-categories" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <h3 className="font-bold text-lg">{t('pos.filters')}</h3>

//           <div className="my-4">
//             <label htmlFor="select_category" className='mb-1 text-sm w-full border rounded-lg px-2 py-2 block text-gray-500'>{t('pos.select_category')}</label>
//             <select ref={categoryFilterDropdownRef} type="text" name="select_category" id='select_category' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.select_category')} >
//               <option value="all">{t('pos.all')}</option>
//               {
//                 categories.filter((category) => category.is_enabled).map((category, index)=><option value={category.id} key={index}>{category.title}</option>)
//               }
//             </select>
//           </div>

//           <div className="modal-action">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={()=>{btnClearSelectedCategory()}} className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-gray-200 text-gray-500">{t('pos.close')}</button>
//               <button onClick={()=>{btnApplyCategoryFilter();}} className="rounded-lg hover:bg-green-800 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-restro-green text-white ml-3">{t('pos.apply')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: category selection */}

//       {/* dialog: variants & addons */}
//       <dialog id="modal-variants-addons" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <div className='flex justify-between items-center'>
//             <h3 className="font-bold text-lg">{t('pos.select_variant_addons')}</h3>
//             <button className='text-red-500 p-2 rounded-full bg-restro-button-hover' onClick={() => document.getElementById('modal-variants-addons').close()}><IconX size={18} stroke={iconStroke}/></button>
//           </div>
//           <div className="my-8 flex gap-2">
//             <div className="flex-1">
//               <h3>{t('pos.variants')}</h3>
//               <div className="flex flex-col gap-2 mt-2">
//               {
//                 menuItems.find((item)=>item.id==selectedItemId)?.variants?.map((variant, index)=>{
//                   const {id, item_id, title, price} = variant;

//                   const fullItem = state.menuItems.find(item => item.id == selectedItemId);

//                   const variantRecipeItems = fullItem.recipeItems?.filter(
//                     r => r.variant_id === id && r.addon_id === 0
//                   );

//                   const isLowStock = variantRecipeItems?.some(
//                     (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
//                   );

//                   const quantitiesPossible = variantRecipeItems?.map(r => {
//                     const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
//                     const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
//                     return Math.floor(currentQty / requiredQty);
//                   });

//                   const minItemsCanBeMade = quantitiesPossible?.length > 0
//                     ? Math.min(...quantitiesPossible)
//                     : null;

//                   return (
//                   <label key={index} className='cursor-pointer label justify-start gap-2'>
//                     <input type="radio" className='radio' name="variants" id="" value={id} defaultChecked={index==0} />
//                     <div>
//                     <span className="label-text">{title} - {currency}{price}</span>
//                     {isLowStock && (
//                         <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
//                           <div className="flex items-center gap-1">
//                             <IconAlertTriangleFilled size={12} />
//                             <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </label>
//                 )})
//               }
//               </div>
//             </div>
//             <div className="flex-1">
//               <h3>{t('pos.addons')}</h3>
//               <div className="flex flex-col gap-2 mt-2">
//               {
//                 state.menuItems.find((item)=>item.id==selectedItemId)?.addons?.map((addon, index)=>{
//                   const {id, item_id, title, price} = addon;

//                   const fullItem = menuItems.find(item => item.id == selectedItemId);

//                   const addonRecipeItems = fullItem.recipeItems?.filter(
//                     (r) => r.addon_id === id && r.variant_id === 0
//                   );

//                   const quantitiesPossible = addonRecipeItems?.map(r => {
//                     const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
//                     const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
//                     return Math.floor(currentQty / requiredQty);
//                   });

//                   const minItemsCanBeMade = quantitiesPossible?.length > 0
//                     ? Math.min(...quantitiesPossible)
//                     : null;

//                   const isLowStock = addonRecipeItems?.some(
//                     (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
//                   );

//                   return (
//                   <label key={index} className='cursor-pointer label justify-start gap-2'>
//                     <input type="checkbox" name="addons" id="" className='checkbox  checkbox-sm' value={id} />
//                     <div>
//                     <span className="label-text">{title} (+{currency}{price})</span>
//                     {isLowStock && (
//                       <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
//                         <div className="flex items-center gap-1">
//                           <IconAlertTriangleFilled size={12} />
//                           <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
//                         </div>
//                       </div>
//                     )}
//                     </div>
//                   </label>
//                 )})
//               }
//               </div>
//             </div>
//           </div>

//           <div className="modal-action">
//             <form method="dialog" className="w-full flex gap-2">
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={()=>{btnAddMenuItemToCartWithVariantsAndAddon()}} className='transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white rounded-xl border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.add')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: variants & addons */}


//       {/* dialog: save draft */}
//       <dialog id="modal-save-draft" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <h3 className="font-bold text-lg">{t('pos.save_cart_items_to_drafts')}</h3>

//           <div className="my-4">
//             <label htmlFor="draftTitleRef" className="mb-1 block text-gray-500 text-sm">{t('pos.reference')}</label>
//             <input ref={draftTitleRef} type="text" name="draftTitleRef" id='draftTitleRef' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.enter_reference_name')} />
//           </div>

//           <div className="modal-action">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
//               <button onClick={()=>{btnAddtoDrafts();}} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: save draft */}

//       {/* dialog: drafts list */}
//       <dialog id="modal-drafts" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box p-0 border border-restro-border-green dark:rounded-2xl'>
//           <div className='flex justify-between items-center sticky top-0 backdrop-blur px-6 py-4 bg-restro-gray'>
//             <h3 className="font-bold text-lg">{t('pos.drafts')}</h3>
//             <form method="dialog" className='flex gap-1'>
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={btnClearDrafts} className='transition active:scale-95 text-red-500 p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconClearAll stroke={iconStroke} /></button>
//               <button className='transition active:scale-95 text-restro-text p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconX stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6 pt-4">
//             {drafts.map((draftItem, index)=>{
//               const {nameRef, date, cart} = draftItem;

//               return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border border-restro-border-green'>
//                 <div className='w-12 h-12 rounded-full flex items-center justify-center text-restro-text bg-restro-bg-gray'>
//                   <IconClipboardList stroke={iconStroke} />
//                 </div>
//                 <div className='flex-1'>
//                   <p>{t('pos.ref')}: {nameRef}</p>
//                   <p className='text-xs'>{cart?.length} {t('pos.cart_items')}</p>
//                   <p className='text-xs text-gray-500'>{date}</p>
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <button onClick={()=>{btnSelectDraftItemToCart(draftItem)}}  className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

//                   <button onClick={()=>{btnDeleteDraftItem(index)}} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
//                 </div>
//               </div>
//             })}
//           </div>


//         </div>
//       </dialog>
//       {/* dialog: drafts list */}

//       <DialogAddCustomer defaultValue={state.addCustomerDefaultValue} onSuccess={(phone, name)=>{
//         setCustomer({value: phone, label: `${name} - (${phone})`})
//         document.getElementById("modal-search-customer").close();
//       }} />

//       {/* dialog: search customer */}
//       <dialog id="modal-search-customer" className="modal modal-bottom sm:modal-middle">
//       <div className='modal-box border border-restro-border-green dark:rounded-2xl h-96'>
//           <div className="flex items-center justify-between">

//             <h3 className="font-bold text-lg">{t('pos.search_customer')}</h3>
//             <form method="dialog">
//               <button onClick={btnClearSearchCustomer} className='btn btn-circle btn-sm text-restro-text border-none bg-restro-gray hover:bg-restro-button-hover'><IconRotate size={18} stroke={iconStroke}/></button>
//               <button className='ml-2 btn btn-circle btn-sm text-red-500 border-none bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke}/></button>
//             </form>
//           </div>

//           <div className="my-4 flex items-end gap-2">
//             <div className='flex-1'>
//               <label htmlFor="searchCustomerRef" className="mb-1 block text-gray-500 text-sm">{t('pos.search_customer')}</label>
//               {/* <input ref={searchCustomerRef} type="search" name="searchCustomerRef" id='searchCustomerRef' className="text-sm w-full border rounded-lg px-4 py-2 bg-gray-50 outline-restro-border-green-light" placeholder="Enter Customer Phone here..." /> */}
//               <AsyncCreatableSelect
//                 menuPlacement='auto'
//                 loadOptions={searchCustomersAsync}
//                 isClearable
//                 noOptionsMessage={(v)=>{return t('pos.type_to_find')}}
//                 onChange={(v)=>{
//                   setCustomer(v);
//                 }}
//                 onCreateOption={(inputValue)=>{
//                   setState({
//                     ...state,
//                     addCustomerDefaultValue: inputValue,
//                   })
//                   document.getElementById("modal-add-customer").showModal();
//                 }}
//                 styles={{
//                   control: (base) => ({
//                     ...base,
//                     backgroundColor: theme === "black" ? "" : "",
//                     borderRadius: "0.5rem",
//                     borderColor: theme === "black" ? "#232323" : "#f3f4f6",
//                     height: 40,
//                     boxShadow: "none",
//                     color: theme === "black" ? "#ffffff" : "#111827", // text color
//                     "&:hover": {
//                       borderColor: theme === "black" ? "#23233" : "#9ca3af",
//                     },
//                   }),
//                   menu: (base) => ({
//                     ...base,
//                     borderRadius: "0.5rem",
//                   }),
//                   menuList: (base) => ({
//                     ...base,
//                     maxHeight: 150,
//                     overflowY: "auto",
//                     borderRadius: "0.5rem",
//                     backgroundColor: theme === "black" ? "#232323" : "white",
//                   }),
//                   option: (base, state) => ({
//                     ...base,
//                     backgroundColor: state.isFocused
//                       ? theme === "black"
//                         ? "#292929"
//                         : "#e5e7eb"
//                       : theme === "black"
//                         ? "#232323"
//                         : "white",
//                     color: theme === "black" ? "#f9fafb" : "#111827",
//                     "&:active": {
//                       backgroundColor: theme === "black" ? "#6b7280" : "#d1d5db",
//                     },
//                   }),
//                   indicatorSeparator: (base) => ({
//                     ...base,
//                     backgroundColor: theme === "black" ? "#ffffff" : "#d1d5db", // divider color based on theme
//                   }),
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: search customer */}

//       {/* dialog: send to kitchen summary */}
//       <dialog id="modal-send-kitchen-summary" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <div className="flex items-center justify-between gap-4">
//             <h3 className="font-bold text-lg">{t('pos.send_order_to_kitchen')}</h3>
//             <form method='dialog'>
//               <button className='text-red-500 p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="my-8 space-y-4 px-1">
//             {[
//               { label: t('pos.items_net_total'), value: state.itemsTotal },
//               { label: t('pos.tax_total'), value: state.taxTotal, prefix: "+" },
//               { label: t('pos.service_charge_total'), value: state.serviceChargeTotal, prefix: "+" },
//             ].map(({ label, value, prefix = "" }, index) => (
//               <div key={index} className='flex items-center justify-between text-restro-text'>
//                 <p>{label}</p>
//                 <p className="text-lg">
//                   {prefix}{currency}{value.toFixed(2)}
//                 </p>
//               </div>
//             ))}

//             <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
//               <p className="text-xl font-medium">{t('pos.payable_total')}</p>
//               <p className="text-xl font-bold text-restro-green">
//                 {currency}{state.payableTotal.toFixed(2)}
//               </p>
//             </div>
//           </div>


//           <div className="modal-action">
//             <form method="dialog" className="w-full">
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={btnSendToKitchen} className='w-full rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.send_to_kitchen')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: send to kitchen summary */}

//       {/* dialog: collect payment & send to kitchen summary */}
//       <dialog id="modal-pay-and-send-kitchen-summary" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <div className="flex items-center justify-between">
//             <h3 className="font-bold text-lg">{t('pos.collect_payment_send_order_to_kitchen')}</h3>
//             <form method='dialog'>
//               <button className='text-red-500 p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="my-8 space-y-4 px-1">
//             {[
//               { label: t('pos.items_net_total'), value: state.itemsTotal },
//               { label: t('pos.tax_total'), value: state.taxTotal, prefix: "+" },
//               { label: t('pos.service_charge_total'), value: state.serviceChargeTotal, prefix: "+" },
//             ].map(({ label, value, prefix = "" }, index) => (
//               <div key={index} className='flex items-center justify-between' text-restro-text>
//                 <p>{label}</p>
//                 <p className="text-lg">
//                   {prefix}{currency}{value.toFixed(2)}
//                 </p>
//               </div>
//             ))}

//             <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
//               <p className="text-xl font-medium">{t('pos.payable_total')}</p>
//               <p className="text-xl font-bold text-restro-green">
//                 {currency}{state.payableTotal.toFixed(2)}
//               </p>
//             </div>
//           </div>

//           <div
//             className={`grid gap-2 grid-cols-3`
//           }
//           >
//             {(paymentTypes||[]).map((paymentType, i)=>{
//               const uniqueId = `icon-${paymentType?.id}`;
//               return <label key={i} className=''>
//                 <input
//                 checked={state?.selectedPaymentType == paymentType?.id}
//                 onChange={e=>{
//                   setState({
//                     ...state,
//                     selectedPaymentType: e.target.value,
//                   });
//                 }} type="radio" name="payment_type" id={uniqueId} value={paymentType?.id} className='peer hidden' />
//                 <label htmlFor={uniqueId} className='border dark:border-restro-gray rounded-2xl flex items-center justify-center gap-1 flex-col px-4 py-3 peer-checked:border-restro-green peer-checked:text-restro-green peer-checked:font-bold cursor-pointer transition'>
//                   {paymentType?.icon ? <div>{PAYMENT_ICONS[paymentType?.icon]}</div>:<></>}
//                   <p className='text-xs'>{paymentType.title}</p>
//                 </label>
//               </label>
//             })}
//           </div>

//           <div className="modal-action flex items-center justify-center w-full">

//             {/* if there is a button in form, it will close the modal */}
//             <button onClick={()=>{btnPayAndSendToKitchen();}} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white w-full fborder border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.collect_payment_send_to_kitchen')}</button>

//           </div>
//         </div>
//       </dialog>
//       {/* dialog: collect payment & send to kitchen summary */}

//       {/* dialog: print-token */}
//       <dialog id="modal-print-token" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
//           <h3 className="font-bold text-lg text-center">{t('pos.order_sent_to_kitchen')}</h3>

//           <div className="my-8 mx-auto w-fit">
//             <div className="flex items-center gap-2">
//               <div className="w-12 h-12 flex items-center justify-center bg-restro-green text-white rounded-full">
//                 <IconCheck stroke={iconStroke} size={32} />
//               </div>
//               <p className="font-bold text-5xl">#{state?.tokenNo}</p>
//             </div>

//             <p className="text-sm mt-4 text-center">{t('pos.order_id')}: {state?.orderId}</p>
//           </div>

//           <div className="modal-action justify-center">
//             <form method="dialog">
//               {/* if there is a button in form, it will close the modal */}
//               <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
//               <button onClick={btnPrintTokenOnly}className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.print_token')}</button>
//             </form>
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: print-token */}

//       {/* dialog: qrorders */}
//       <dialog id="modal-qrorders" className="modal modal-bottom sm:modal-middle">
//         <div className='modal-box border border-restro-border-green dark:rounded-2xl p-0'>
//           <div className="flex justify-between items-center sticky top-0 px-6 py-4">
//             <h3 className="font-bold text-lg">{t('pos.qr_orders')}</h3>
//             <form method="dialog" className='flex gap-2'>
//               {/* if there is a button in form, it will close the modal */}
//               <button onClick={btnClearQROrders} className="rounded-full hover:bg-red-200 transition active:scale-95 bg-red-50 dark:bg-red-500 dark:text-white text-red-500 w-9 h-9 flex items-center justify-center"><IconClearAll stroke={iconStroke} /></button>
//               <button className="rounded-full hover:bg-gray-200 dark:hover:bg-black transition active:scale-95 bg-gray-100 dark:bg-restro-gray text-gray-500 dark:text-white w-9 h-9 flex items-center justify-center"><IconX stroke={iconStroke} /></button>
//             </form>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6">
//             {state?.qrOrders?.map((qrOrder, index)=>{
//               const { customer_type, customer_id, customer_name, table_id, table_title, items, id } = qrOrder;

//               return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border dark:border-restro-gray'>
//                 <div className='w-12 h-12 rounded-full bg-gray-100 dark:bg-restro-gray dark:text-white text-gray-500 flex items-center justify-center'>
//                   <IconClipboardList stroke={iconStroke} />
//                 </div>
//                 <div className='flex-1'>
//                   <div className="flex items-center gap-1 text-xs text-gray-500">
//                     <IconArmchair2 stroke={iconStroke} size={14} />
//                     <p className=''>{table_title || "N/A"}</p>
//                   </div>
//                   <div className="flex items-center gap-1 text-xs">
//                     <IconUser stroke={iconStroke} size={14} />
//                     <p className=''>{customer_type == "WALKIN" ? "WALKIN" : customer_name}</p>
//                   </div>
//                   <p className='text-xs'>{items?.length} {t('pos.cart_items')}</p>
//                 </div>
//                 <div className="flex flex-col gap-1">
//                   <button onClick={()=>{btnSelectQROrder(qrOrder)}} className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

//                   <button onClick={()=>{btnCancelQROrder(id)}} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
//                 </div>
//               </div>
//             })}
//           </div>
//         </div>
//       </dialog>
//       {/* dialog: qrorders */}
//     </Page>
//   )
// }

import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import Page from "../components/Page";
import ApiClient from "../helpers/ApiClient";
import OfflineStorage from "../helpers/OfflineStorage";
import { IconPlus, IconNotes, IconArmchair, IconScreenShare, IconSearch, IconDeviceFloppy, IconChefHat, IconCash, IconMinus, IconNote, IconTrash, IconFilter, IconPhoto, IconFilterFilled, IconClipboardList, IconX, IconClearAll, IconPencil, IconCheck, IconCarrot, IconRotate, IconQrcode, IconArmchair2, IconUser, IconCategory, IconGridDots, IconLayoutGrid, IconListDetails, IconListTree, IconMenu4, IconLayoutGridFilled, IconMenu2, IconLayoutList, IconLayout2, IconLayout2Filled, IconAlertTriangleFilled, IconGift, IconBed, IconReceipt, IconDiscount, IconCalculator, IconCreditCard, IconScale, IconRotateClockwise, IconBuildingSkyscraper } from "@tabler/icons-react";
import { VITE_BACKEND_SOCKET_IO, iconStroke } from "../config/config";
import { cancelAllQROrders, cancelQROrder, createOrder, updateOrder, createOrderAndInvoice, getDrafts, getQROrders, getQROrdersCount, initPOS, setDrafts } from "../controllers/pos.controller";
import { CURRENCIES } from '../config/currencies.config';
import { PAYMENT_ICONS } from "../config/payment_icons";
import { toast } from "react-hot-toast";
import { searchCustomer } from '../controllers/customers.controller';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { setDetailsForReceiptPrint } from '../helpers/ReceiptHelper';
import { SocketContext } from "../contexts/SocketContext";
import { initSocket } from '../utils/socket';
import { getImageURL } from '../helpers/ImageHelper';
import { getUserDetailsInLocalStorage } from '../helpers/UserDetails';
import AsyncCreatableSelect from 'react-select/async-creatable';
import DialogAddCustomer from '../components/DialogAddCustomer';
import POSMenuItemDetailedView from '../components/POSMenuItemDetailedView';
import POSMenuItemCompactView from '../components/POSMenuItemCompactView';
import TipInputCard from '../components/TipInputCard';
import { clsx } from "clsx";
import { useTheme } from '../contexts/ThemeContext';
import { playQROrderSound, playNewOrderSound, unlockAudio } from '../helpers/SoundHelper';

const SafeIconPrinter = ({ size = 24, stroke = 2, className = "", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
    <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
    <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
    <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" />
  </svg>
);

export default function POSPage() {
  const { t } = useTranslation();
  const user = getUserDetailsInLocalStorage();
  const { socket, isSocketConnected } = useContext(SocketContext);
  const navigate = useNavigate();
  const location = useLocation();
  const editOrderData = location.state?.editOrder || null;
  const { theme } = useTheme();
  const diningOptionRef = useRef();
  const tableRef = useRef();
  const roomRef = useRef();
  const [diningOption, setDiningOption] = useState("");
  const [selectedTable, setSelectedTable] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");

  // dialog: notes ref
  const dialogNotesIndexRef = useRef();
  const dialogNotesTextRef = useRef();
  // dialog: notes ref

  // dialog: category filter
  const categoryFilterDropdownRef = useRef(null);
  // dialog: category filter

  // dialog: category filter
  const draftTitleRef = useRef(null);
  // dialog: category filter

  // dialog: search customer
  const searchCustomerRef = useRef(null);
  const modalCustomerSearchRef = useRef(null);
  const printReceiptRef = useRef(null);
  // dialog: search customer

  const lastPlacedOrderIdRef = useRef(null);

  const tapSound = new Audio("/tap.mp3");

  const [state, setState] = useState({
    view: "detailed",
    categories: [],
    menuItems: [],
    paymentTypes: [],
    printSettings: null,
    storeSettings: null,
    storeTables: [],
    serviceCharge: null,
    currency: "",
    isLoading: true,
    rooms: [],

    cartItems: [],
    customerType: "WALKIN",
    customer: null,
    addCustomerDefaultValue: null,

    searchQuery: "",
    selectedCategory: "all",

    selectedItemId: null,

    drafts: [],

    itemsTotal: 0,
    taxTotal: 0,
    serviceChargeTotal: 0,
    payableTotal: 0,

    orderId: null,
    tokenNo: null,

    qrOrdersCount: 0,
    qrOrders: [],
    selectedQrOrderItem: null,

    selectedPaymentType: null,
    cashTendered: 0,

    loyaltySettings: null,
    customerLoyalty: null,
    loyaltyRedemptionAmount: 0,
    loyaltyPointsRedeemed: 0,
    loyaltyItemsRedeemed: 0,
    multiPayments: [],
    discountType: "fixed", // "fixed" or "percent"
    tipAmount: 0,
    tipData: {
      distribution_type: "direct",
      employee_id: "",
      employee_name: "",
      pool_department: "Restaurant Service",
      notes: ""
    },
    customerSearchResults: [],
    isCompletingPayment: false,
  });

  useEffect(() => {
    const fetchCustomerLoyalty = async () => {
      if (state.customer && state.customer.phone) {
        try {
          const data = await getCustomerLoyalty(state.customer.phone);
          setState(prev => ({ ...prev, customerLoyalty: data }));
        } catch (error) {
          console.error("Failed to fetch customer loyalty", error);
        }
      } else {
        setState(prev => ({ ...prev, customerLoyalty: null, loyaltyRedemptionAmount: 0, loyaltyPointsRedeemed: 0, loyaltyItemsRedeemed: 0 }));
      }
    };
    fetchCustomerLoyalty();
  }, [state.customer]);

  // Load edit order data after POS initializes
  useEffect(() => {
    if (!editOrderData || state.isLoading || state.menuItems.length === 0) return;

    // Map order items back to cartItem format using menuItems from POS init
    const loadedCartItems = editOrderData.items.map(item => {
      // Find the full menu item to get recipeItems, addons, etc.
      const menuItem = state.menuItems.find(m => m.id === item.item_id) || {};
      return {
        ...menuItem,
        id: item.item_id,
        title: item.item_title || menuItem.title,
        price: item.price,
        quantity: item.quantity,
        notes: item.notes || null,
        variant_id: item.variant_id || null,
        addons_ids: item.addons ? item.addons.map(a => a.id) : [],
        is_complementary: item.is_complementary || 0,
        recipeItems: menuItem.recipeItems || [],
        variants: menuItem.variants || [],
        addons: menuItem.addons || [],
        // Keep variant label for display
        variant: item.variant_id ? { id: item.variant_id, title: item.variant_title } : null,
        status: item.status,
      };
    });

    // Set table, room, and dining option if available
    if (editOrderData.tableId) {
      setSelectedTable(String(editOrderData.tableId));
      if (tableRef.current) tableRef.current.value = editOrderData.tableId;
    }
    if (editOrderData.deliveryType) {
      setDiningOption(editOrderData.deliveryType);
      if (diningOptionRef.current) diningOptionRef.current.value = editOrderData.deliveryType;
    }
    if (editOrderData.source && editOrderData.deliveryType === 'room') {
      setSelectedRoom(String(editOrderData.source));
      if (roomRef.current) roomRef.current.value = editOrderData.source;
    }

    setState(prev => ({
      ...prev,
      cartItems: loadedCartItems,
      editOrderId: editOrderData.orderId,
      customerType: editOrderData.customerType || 'WALKIN',
      customer: editOrderData.customer?.phone ? editOrderData.customer : null,
    }));

    toast.success(`Editing Order #${editOrderData.orderId}`, { icon: '✏️' });
  }, [state.isLoading, state.menuItems.length]);

  // Handle pre-selection from Table/Room Grid page or Customer Ledger
  useEffect(() => {
    if (state.isLoading) return;
    
    const preSelectTable = location.state?.preSelectTable;
    const preSelectRoom = location.state?.preSelectRoom;
    const preSelectDiningOption = location.state?.preSelectDiningOption;
    const preSelectCustomer = location.state?.preSelectCustomer;
    
    if (!preSelectTable && !preSelectRoom && !preSelectDiningOption && !preSelectCustomer) return;
    
    if (preSelectDiningOption) {
      setDiningOption(preSelectDiningOption);
      if (diningOptionRef.current) diningOptionRef.current.value = preSelectDiningOption;
    }
    
    if (preSelectTable) {
      setSelectedTable(String(preSelectTable));
      if (tableRef.current) tableRef.current.value = preSelectTable;
    }
    
    if (preSelectRoom) {
      setSelectedRoom(String(preSelectRoom));
      if (roomRef.current) roomRef.current.value = preSelectRoom;
    }

    if (preSelectCustomer && (preSelectCustomer.phone || preSelectCustomer.name)) {
      const custPhone = preSelectCustomer.phone || preSelectCustomer.name;
      const custName = preSelectCustomer.name || custPhone;
      setState(prev => ({
        ...prev,
        customer: { phone: custPhone, name: custName },
        customerType: "CUSTOMER"
      }));
      toast.success(`Selected customer: ${custName}`, { icon: '👤' });
    }
  }, [state.isLoading, location.state]);

  useEffect(() => {
    _initPOS();
  }, []);

  useEffect(() => {
    const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal } = calculateOrderSummary();
    setState(prev => ({
      ...prev,
      itemsTotal,
      taxTotal,
      serviceChargeTotal,
      payableTotal
    }));
  }, [state.cartItems, state.discount, state.serviceCharge]);

  const { categories, menuItems, paymentTypes, printSettings, storeSettings, storeTables, currency, cartItems, searchQuery, selectedCategory, selectedItemId, drafts, customer, customerType, isLoading } = state;



  function sendNewOrderEvent(tokenNo, orderId) {
    if (isSocketConnected) {
      socket.emit('new_order_backend', { tokenNo, orderId }, user.tenant_id);
    } else {
      // Handle disconnected state (optional)
      initSocket();
      socket.emit('new_order_backend', { tokenNo, orderId }, user.tenant_id);
    }
  }

  function playTapSound() {
    tapSound.play();
  }

  async function _initPOS() {
    try {
      const res = await initPOS();
      let totalQROrders = 0;

      if (res.status == 200) {
        const data = res.data || {};

        const storeSettings = data?.storeSettings || {
          tenant_id: data?.tenantId || 1,
          store_name: "Store",
          currency: "NPR",
          business_type: "restaurant",
          stock_selling_policy: "allow_negative",
          sync_mode: getSyncMode()
        };

        const currency = CURRENCIES.find((c) => c.cc == (storeSettings?.currency || 'NPR'));

        try {
          totalQROrders = await _getQROrdersCount();
        } catch (error) {
          console.log(error);
        }

        const savedView = sessionStorage.getItem('view') || 'detailed';

        // Fetch auxiliary data in parallel
        let roomsData = [];
        try {
          const roomsRes = await ApiClient.get("/rooms/list-basic").catch(async () => {
            return await ApiClient.get("/rooms").catch(() => ({ data: [] }));
          });
          roomsData = Array.isArray(roomsRes) ? roomsRes : (roomsRes?.data || []);
        } catch (e) {
          roomsData = [];
        }

        if (!roomsData || roomsData.length === 0) {
          roomsData = OfflineStorage.getCachedRooms() || [];
        } else {
          try { OfflineStorage.cacheRooms(roomsData); } catch (e) {}
        }

        // Deduplicate rooms by name
        const seenNames = new Set();
        const cleanRooms = (Array.isArray(roomsData) ? roomsData : []).filter(r => {
          if (!r || !r.name) return false;
          const clean = String(r.name).trim();
          if (!clean || clean === 'null' || clean.includes('16000001')) return false;
          const key = clean.toLowerCase();
          if (seenNames.has(key)) return false;
          seenNames.add(key);
          return true;
        });

        const loyaltySettings = await ApiClient.get("/loyalty/settings").then(r => r.data).catch(() => null);

        if (data.categories && Array.isArray(data.categories)) {
          try { localStorage.setItem('cached_categories', JSON.stringify(data.categories)); } catch(e) {}
        }

        setState((prev) => ({
          ...prev,
          view: savedView,
          categories: data.categories || [],
          menuItems: data.menuItems || [],
          paymentTypes: data.paymentTypes || [],
          printSettings: data.printSettings || null,
          storeSettings: storeSettings,
          storeTables: data.storeTables || [],
          serviceCharge: data.serviceCharge || 0,
          currency: currency?.symbol || "रु",
          qrOrdersCount: totalQROrders || 0,
          isLoading: false,
          loyaltySettings,
          rooms: cleanRooms,
        }));
      } else {
        setState((prev) => ({
          ...prev,
          isLoading: false,
        }));
        toast.error("Failed to load POS data. Please refresh.");
      }
    } catch (error) {
      console.error(error);
      setState((prev) => ({
        ...prev,
        isLoading: false,
      }));
      toast.error("Error connecting to server. Please try again.");
    }
  }

  async function _getQROrdersCount() {
    try {
      const res = await getQROrdersCount();
      if (res.status == 200) {
        const data = res.data;

        return data?.totalQROrders || 0;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  useEffect(() => {
    if (!socket) return;

    const onConnect = () => {
      if (user?.tenant_id) {
        socket.emit("authenticate", user.tenant_id);
      }
    };

    if (user?.tenant_id) {
      socket.emit("authenticate", user.tenant_id);
    }

    const handleQROrder = async (payload) => {
      try {
        console.log("POS received new QR order:", payload);
        unlockAudio();
        const sourceLabel = payload?.source || (payload?.deliveryType === 'room' ? 'Room Scanner' : (payload?.tableId ? `Table ${payload.tableId}` : 'Table Scanner'));
        playQROrderSound({
          source: sourceLabel,
          deliveryType: payload?.deliveryType,
          customerName: payload?.customerName,
          tableId: payload?.tableId,
        });

        const totalQROrders = await _getQROrdersCount();

        setState((prevState) => ({
          ...prevState,
          qrOrdersCount: totalQROrders || 0
        }));
      } catch (error) {
        console.log(error);
      }
    };

    const handleOrderUpdate = async (payload) => {
      try {
        const totalQROrders = await _getQROrdersCount();
        setState((prevState) => ({
          ...prevState,
          qrOrdersCount: totalQROrders || 0
        }));

      } catch (e) {
        console.error('[POSPage] Order update count error:', e);
      }
    };

    socket.on('connect', onConnect);
    socket.on('new_qrorder', handleQROrder);
    socket.on('new_order_notification', handleQROrder);
    socket.on('new_order', handleOrderUpdate);
    socket.on('order_update', handleOrderUpdate);

    return () => {
      socket.off('connect', onConnect);
      socket.off('new_qrorder', handleQROrder);
      socket.off('new_order_notification', handleQROrder);
      socket.off('new_order', handleOrderUpdate);
      socket.off('order_update', handleOrderUpdate);
    };
  }, [socket, isSocketConnected, user?.tenant_id]);

  if (isLoading) {
    return <Page className='px-4 py-3 flex flex-col min-h-0'>
      <div className='mt-4 h-[calc(100vh-136px)] flex gap-4 skeleton'>
        <div className='border border-restro-border-green-light rounded-2xl h-full w-[70%] overflow-y-auto'></div>
        <div className='border border-restro-border-green-light rounded-2xl h-full w-[30%] relative flex flex-col'></div>
      </div>
    </Page>
  }


  // cart
  function canPrepareMenuItem(menuItem, quantity = 1, selectedVariantId = null, selectedAddonIds = []) {
    const policy = state?.storeSettings?.stock_selling_policy || state?.storeSettings?.stockSellingPolicy || 'allow_negative';
    if (policy === 'allow_negative') {
      return { canPrepare: true };
    }

    if (!menuItem?.recipeItems || menuItem.recipeItems.length === 0) {
      return { canPrepare: true };
    }

    const usageMap = {};

    menuItem.recipeItems.forEach((recipe) => {
      const appliesToBase = recipe.variant_id === 0 && recipe.addon_id === 0;
      const appliesToVariant = recipe.variant_id > 0 && recipe.variant_id == selectedVariantId;
      const appliesToAddon = recipe.addon_id > 0 && selectedAddonIds.map(String).includes(recipe.addon_id.toString());

      if (appliesToBase || appliesToVariant || appliesToAddon) {
        const invId = recipe.inventory_item_id;
        const requiredQty = parseFloat(String(String(recipe.recipe_quantity).replace(/,/g, "")).replace(/,/g, "")) * quantity;

        if (!usageMap[invId]) {
          usageMap[invId] = {
            ingredient_title: recipe.ingredient_title,
            total_required: 0,
            current_quantity: parseFloat(String(String(recipe.current_quantity || 0).replace(/,/g, "")).replace(/,/g, "")),
          };
        }

        usageMap[invId].total_required += requiredQty;
      }
    });

    for (const invId in usageMap) {
      const { ingredient_title, total_required, current_quantity } = usageMap[invId];
      if (current_quantity < total_required) {
        console.warn(
          `Cannot prepare '${menuItem.title}' - Ingredient '${ingredient_title}' is insufficient`
        );
        return {
          canPrepare: false,
          reason: `Cannot sell '${menuItem.title}' - Ingredient '${ingredient_title}' is out of stock (${current_quantity} available, need ${total_required})`
        };
      }
    }

    return { canPrepare: true };
  }

  function addItemToCart(item) {
    const qtyToAdd = (item.quantity && parseInt(item.quantity, 10) > 0) ? parseInt(item.quantity, 10) : 1;

    const getAddonKey = (ci) => {
      if (Array.isArray(ci.addons_ids) && ci.addons_ids.length > 0) {
        return ci.addons_ids
          .map(a => (typeof a === 'object' && a !== null ? String(a.id) : String(a)).trim())
          .filter(Boolean)
          .sort()
          .join(',');
      }
      return '';
    };

    const getNormalizedVariant = (val) => (val !== undefined && val !== null && val !== "" && val !== 0 && val !== "0") ? String(val) : "";

    const itemVariantId = getNormalizedVariant(item.variant_id);
    const itemAddonKey = getAddonKey(item);
    const itemNotes = (item.notes || '').trim();

    const currentCart = state.cartItems || [];
    const existingIndex = currentCart.findIndex(ci => {
      const ciVariantId = getNormalizedVariant(ci.variant_id);
      const ciAddonKey = getAddonKey(ci);
      const ciNotes = (ci.notes || '').trim();

      return (
        String(ci.id) === String(item.id) &&
        ciVariantId === itemVariantId &&
        ciAddonKey === itemAddonKey &&
        ciNotes === itemNotes &&
        !ci.is_complementary &&
        !item.is_complementary &&
        Math.abs(Number(String(ci.price || 0).replace(/,/g, "")) - Number(String(item.price || 0).replace(/,/g, ""))) < 0.001
      );
    });

    if (existingIndex !== -1) {
      const existingItem = currentCart[existingIndex];
      const currentQty = parseInt(existingItem.quantity, 10) || 1;
      const newQty = currentQty + qtyToAdd;

      const targetItem = {
        ...existingItem,
        recipeItems: (existingItem.recipeItems && existingItem.recipeItems.length > 0) ? existingItem.recipeItems : (item.recipeItems || [])
      };

      const check = canPrepareMenuItem(
        targetItem,
        newQty,
        targetItem.variant_id,
        targetItem.addons_ids || []
      );

      if (!check.canPrepare) {
        toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
        return;
      }

      const newCartItems = [...currentCart];
      newCartItems[existingIndex] = {
        ...existingItem,
        quantity: newQty
      };

      setState(prev => ({
        ...prev,
        cartItems: newCartItems
      }));
      playTapSound();
      return;
    }

    // New item to cart
    const check = canPrepareMenuItem(item, qtyToAdd, item.variant_id, item.addons_ids || []);
    if (!check.canPrepare) {
      toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
      return;
    }

    const modifiedItem = {
      ...item,
      quantity: qtyToAdd,
      notes: item.notes || null
    };

    setState(prev => ({
      ...prev,
      cartItems: [...(prev.cartItems || []), modifiedItem]
    }));
    playTapSound();
  }

  function removeItemFromCart(index) {
    setState({
      ...state,
      cartItems: cartItems.filter((c, i) => i !== index)
    })
    playTapSound();
  }

  function addCartItemQuantity(index, currentQuantity) {
    const newQuantity = currentQuantity + 1;
    const newCartItems = cartItems;

    const check = canPrepareMenuItem(newCartItems[index], newQuantity, newCartItems[index].variant_id, newCartItems[index].addons_ids || []);
    if (!check.canPrepare) {
      toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
      return;
    }

    newCartItems[index].quantity = newQuantity;

    setState({
      ...state,
      cartItems: [...newCartItems]
    });
    playTapSound();
  }
  function minusCartItemQuantity(index, currentQuantity) {
    const newQuantity = currentQuantity - 1;
    let newCartItems = cartItems;

    newCartItems[index].quantity = newQuantity;

    if (newQuantity == 0) {
      newCartItems = cartItems.filter((v, i) => i != index);
    }

    setState({
      ...state,
      cartItems: [...newCartItems]
    });
    playTapSound();
  }

  function updateDirectCartItemQuantity(index, rawValue) {
    if (rawValue === "") {
      const newCartItems = [...cartItems];
      newCartItems[index].quantity = "";
      setState(prev => ({
        ...prev,
        cartItems: newCartItems
      }));
      return;
    }

    const parsed = parseInt(rawValue, 10);
    if (isNaN(parsed) || parsed < 1) return;

    const newCartItems = [...cartItems];
    const check = canPrepareMenuItem(newCartItems[index], parsed, newCartItems[index].variant_id, newCartItems[index].addons_ids || []);
    if (!check.canPrepare) {
      toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
      return;
    }

    newCartItems[index].quantity = parsed;
    setState(prev => ({
      ...prev,
      cartItems: newCartItems
    }));
  }
  // cart

  // order notes
  const btnOpenNotesModal = (index, notes) => {
    dialogNotesIndexRef.current.value = index;
    dialogNotesTextRef.current.value = notes;
    document.getElementById('modal-notes').showModal()
  }
  const btnAddNotes = () => {
    const index = dialogNotesIndexRef.current.value;
    const notes = dialogNotesTextRef.current.value || null;

    const newCartItems = cartItems;
    newCartItems[index].notes = notes;

    setState({
      ...state,
      cartItems: newCartItems
    })
  };
  // order notes

  // category filter modal
  const btnOpenCategoryFilterModal = () => {
    categoryFilterDropdownRef.current.value = selectedCategory;
    document.getElementById('modal-categories').showModal()
  }
  const btnApplyCategoryFilter = () => {
    const selectedCategoryFromDropdown = categoryFilterDropdownRef.current.value || "";
    setState({
      ...state,
      selectedCategory: selectedCategoryFromDropdown
    })
  }
  const btnClearSelectedCategory = () => {
    setState({
      ...state,
      selectedCategory: "all"
    })
  };
  // category filter modal

  // variant, addon modal

  const resetVariantsAndAddons = () => {
    const itemVariants = document.getElementsByName("variants");
    itemVariants.forEach((item, index) => {
      item.checked = index === 0;
    });

    const itemAddons = document.getElementsByName("addons");
    itemAddons.forEach((item) => {
      item.checked = false;
    });
  };

  const btnOpenVariantAndAddonModal = (menuItemId) => {

    resetVariantsAndAddons();

    setState({
      ...state,
      selectedItemId: menuItemId
    })
    document.getElementById('modal-variants-addons').showModal()
  }
  const btnAddMenuItemToCartWithVariantsAndAddon = () => {
    let price = 0;
    let selectedVariantId = null;
    const selectedAddonsId = [];

    const itemVariants = document.getElementsByName("variants");
    itemVariants.forEach((item) => {
      if (item.checked) {
        selectedVariantId = item.value;
        return;
      }
    })

    const itemAddons = document.getElementsByName("addons");
    itemAddons.forEach((item) => {
      if (item.checked) {
        selectedAddonsId.push(item.value);
      }
    })

    // get selected menu item
    const selectedItem = menuItems.find((item) => item.id == selectedItemId);

    const addons = selectedItem?.addons || [];
    const variants = selectedItem?.variants || [];

    let selectedVariant = null;
    if (selectedVariantId) {
      selectedVariant = variants.find((v) => v.id == selectedVariantId);
      price = parseFloat(String(String(selectedVariant.price).replace(/,/g, "")).replace(/,/g, ""));
    } else {
      price = parseFloat(String(String(selectedVariant?.price ?? selectedItem.price).replace(/,/g, "")).replace(/,/g, ""))
    }

    let selectedAddons = [];
    if (selectedAddonsId.length > 0) {
      selectedAddons = selectedAddonsId.map((addonId) => addons.find((addon) => addon.id == addonId))
      selectedAddons.forEach((addon) => {
        const addonPrice = parseFloat(String(String(addon.price).replace(/,/g, "")).replace(/,/g, ""));
        price = price + addonPrice
      });
    }

    const check = canPrepareMenuItem(selectedItem, 1/**quantity */, selectedVariantId, selectedAddonsId);

    if (!check.canPrepare) {
      toast.error(check.reason || t('inventory.insufficient_stock_message_pos'));
      return;
    }

    const itemCart = { ...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons }
    addItemToCart(itemCart)
  };
  // variant, addon modal

  // drafts
  const btnOpenSaveDraftModal = () => {
    if (cartItems.length == 0) {
      toast.error(t('pos.empty_cart'));
      return;
    }
    document.getElementById('modal-save-draft').showModal()
  }
  const btnAddtoDrafts = () => {
    const drafts = getDrafts();

    const nameRef = draftTitleRef.current.value || "";
    const date = new Date().toLocaleString();

    const draftItem = {
      nameRef: nameRef,
      date,
      cart: cartItems
    };

    drafts.push(draftItem);

    setDrafts(drafts);
    setState({
      ...state,
      cartItems: []
    })
  };

  const btnInitNewOrder = () => {
    setState({
      ...state,
      cartItems: [],
      customer: null,
      customerType: "WALKIN",
      selectedQrOrderItem: null,
    })
    playTapSound();
  }

  const btnOpenDraftsModal = () => {
    const drafts = getDrafts();
    setState({
      ...state,
      drafts: [...drafts]
    });
    document.getElementById("modal-drafts").showModal();
  }

  const btnDeleteDraftItem = index => {
    const drafts = getDrafts();
    const newDrafts = drafts.filter((v, i) => i != index);

    setDrafts(newDrafts);

    setState({
      ...state,
      drafts: [...newDrafts]
    });
  };

  const btnClearDrafts = () => {
    setDrafts([]);
    setState({
      ...state,
      drafts: []
    });
  };
  const btnSelectDraftItemToCart = draftItem => {
    const { nameRef, date, cart } = draftItem;

    setState({
      ...state,
      cartItems: [...cart]
    });

    document.getElementById("modal-drafts").close();
  };
  // drafts

  // QR Menu Orders
  const btnShowQROrdersModal = async () => {
    try {
      const res = await getQROrders();
      if (res.status == 200) {
        const data = res.data;
        setState({
          ...state,
          qrOrders: [...data]
        })
        document.getElementById("modal-qrorders").showModal();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const btnClearQROrders = async () => {
    const isConfirm = window.confirm(t('pos.delete_confirm'));
    if (!isConfirm) {
      return;
    }
    try {
      toast.loading(t('pos.please_wait'));
      const res = await cancelAllQROrders();
      if (res.status == 200) {
        toast.dismiss();
        toast.success(res.data.message);
        setState((prevState) => ({
          ...prevState, qrOrders: [], qrOrdersCount: 0,
        }))
        playTapSound();
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.getting_issues');
      console.log(error);
      toast.dismiss();
      toast.error(message);
    }
  }
  const btnCancelQROrder = async (orderId) => {
    const isConfirm = window.confirm(t('pos.delete_confirm'));
    if (!isConfirm) {
      return;
    }
    try {
      toast.loading(t('pos.please_wait'));
      const res = await cancelQROrder(orderId);
      if (res.status == 200) {
        toast.dismiss();
        toast.success(res.data.message);

        const newQROrders = state.qrOrders.filter((item) => item.id != orderId);
        const newQROrderItem = state.qrOrdersCount - 1;

        setState((prevState) => ({
          ...prevState, qrOrders: [...newQROrders], qrOrdersCount: newQROrderItem,
        }))
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.getting_issues');
      console.log(error);
      toast.dismiss();
      toast.error(message);
    }
  }
  const btnSelectQROrder = (qrOrder) => {
    console.log(qrOrder);

    if (qrOrder.table_id) {
      tableRef.current.value = qrOrder.table_id;
    }

    // const itemCart = {...selectedItem, price: price, variant_id: selectedVariantId, variant: selectedVariant, addons_ids: selectedAddonsId, addons: selectedAddons}

    const modifiedCart = qrOrder.items.map((item) => {
      const id = item.item_id;

      let selectedVariant = {
        id: item.variant_id,
        item_id: id,
        price: item.variant_price,
        title: item.variant_title,
      }

      return {
        ...item,
        id: id,
        title: item.item_title,
        addons_ids: item?.addons?.map((i) => i.id),
        variant: selectedVariant || null,
        variant_id: item.variant_id || null,
      }
    })

    setState({
      ...state,
      cartItems: modifiedCart,
      selectedQrOrderItem: qrOrder.id,
      customerType: qrOrder.customer_type,
      customer: { phone: qrOrder.customer_id, name: qrOrder.customer_name },
      deliveryType: qrOrder.delivery_type || "dine_in",
      source: qrOrder.source || null,
      tableId: qrOrder.table_id || null,
    })
    playTapSound();

    document.getElementById('modal-qrorders').close();
  };
  // QR MEnu Orders

  // search customer modal
  const btnOpenSearchCustomerModal = () => {
    document.getElementById("modal-search-customer").showModal();
  };
  const btnClearSearchCustomer = () => {
    setState({
      ...state,
      customerType: "WALKIN",
      customer: null,
      customerLoyalty: null,
      loyaltyRedemptionAmount: 0,
      loyaltyPointsRedeemed: 0,
      loyaltyItemsRedeemed: 0
    })
  }
  const btnSearchCustomer = async () => {
    const phone = searchCustomerRef.current.value;

    if (!phone) {
      toast.error(t('pos.please_provide_phone'));
      return;
    }

    try {
      toast.loading(t('pos.please_wait'));
      const resp = await searchCustomer(phone);
      toast.dismiss();
      if (resp.status == 200) {
        setState({
          ...state,
          customer: resp.data,
          customerType: "CUSTOMER"
        })
        document.getElementById("modal-search-customer").close()
      }

    } catch (error) {
      console.log(error);
      const message = error.response.data.message || t('pos.error_getting_details');
      toast.dismiss();
      toast.error(message);
    }
  }
  // search customer modal


  // send to kitchen modal
  function calculateOrderSummary() {
    let rawItemsTotal = 0;
    let payableTotal = 0;
    let serviceChargeTotal = 0;
    let taxTotal = 0;

    // 1. Get raw base amounts
    cartItems.forEach((item) => {
      if (item.is_complementary) return;
      const taxRate = Number(String(String(item.tax_rate).replace(/,/g, "")).replace(/,/g, "")) || 0;
      const itemPrice = Number(String(String(item.price).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(item.quantity).replace(/,/g, "")).replace(/,/g, ""));

      let itemBase = itemPrice;
      if (item.tax_type === "inclusive") {
        itemBase = itemPrice / (1 + taxRate / 100);
      }
      rawItemsTotal += itemBase;
    });

    // 2. Calculate Discount on the Base Amount
    let discountAmount = 0;
    const discountValue = Number(String(String(state.discount || 0).replace(/,/g, "")).replace(/,/g, ""));
    if (state.discountType === "percent") {
      discountAmount = (rawItemsTotal * discountValue) / 100;
    } else {
      discountAmount = discountValue;
    }

    // Safety check for over-discounting
    if (discountAmount > rawItemsTotal) discountAmount = rawItemsTotal;

    const discountRatio = rawItemsTotal > 0 ? discountAmount / rawItemsTotal : 0;

    // 3. Calculate Service Charge on the Base Amount
    if (state.serviceCharge) {
      serviceChargeTotal = (rawItemsTotal * Number(String(String(state.serviceCharge).replace(/,/g, "")).replace(/,/g, ""))) / 100;
    }
    const scRatio = rawItemsTotal > 0 ? serviceChargeTotal / rawItemsTotal : 0;

    // 4. Calculate Tax and Finals Item by Item
    let itemsTotal = 0; // This will be the actual Subtotal (Base)
    cartItems.forEach((item) => {
      if (item.is_complementary) return;
      const taxRate = Number(String(String(item.tax_rate).replace(/,/g, "")).replace(/,/g, "")) || 0;
      const itemPrice = Number(String(String(item.price).replace(/,/g, "")).replace(/,/g, "")) * Number(String(String(item.quantity).replace(/,/g, "")).replace(/,/g, ""));

      let itemBase = itemPrice;
      if (item.tax_type === "inclusive") {
        itemBase = itemPrice / (1 + taxRate / 100);
      }

      // Proportional discount and service charge for this item
      const itemDiscount = itemBase * discountRatio;
      const itemSC = itemBase * scRatio;

      // Taxable amount is Base - Discount + SC
      const itemTaxable = itemBase - itemDiscount + itemSC;

      // Calculate Tax
      let itemTax = 0;
      if (item.tax_type === "exclusive" || item.tax_type === "inclusive") {
        itemTax = (itemTaxable * taxRate) / 100;
      }

      itemsTotal += itemBase;
      taxTotal += itemTax;
      payableTotal += (itemTaxable + itemTax);
    });

    payableTotal -= state.loyaltyRedemptionAmount || 0;

    return {
      itemsTotal, taxTotal, serviceChargeTotal, payableTotal, discountAmount
    }
  };
  const getModalCalculations = () => {
    let subTotal = 0;
    (state.cartItems || []).forEach((item) => {
      if (item.is_complementary) return;
      const taxRate = Number(String(item.tax_rate || 0).replace(/,/g, "")) || 0;
      const itemPrice = Number(String(item.price || 0).replace(/,/g, "")) * Number(String(item.quantity || 1).replace(/,/g, ""));
      let itemBase = itemPrice;
      if (item.tax_type === "inclusive") {
        itemBase = itemPrice / (1 + taxRate / 100);
      }
      subTotal += itemBase;
    });

    const discVal = Number(state.discount || 0);
    const discAmt = state.discountType === "percent" ? (subTotal * discVal / 100) : discVal;
    const effectiveDiscAmt = Math.min(discAmt, subTotal);
    const discPercent = subTotal > 0 && effectiveDiscAmt > 0 ? Math.round((effectiveDiscAmt / subTotal) * 100) : 0;

    let serviceChargeTotal = 0;
    if (state.serviceCharge) {
      serviceChargeTotal = (subTotal * Number(String(state.serviceCharge).replace(/,/g, ""))) / 100;
    }

    const discountRatio = subTotal > 0 ? effectiveDiscAmt / subTotal : 0;
    const scRatio = subTotal > 0 ? serviceChargeTotal / subTotal : 0;

    let taxAmt = 0;
    (state.cartItems || []).forEach((item) => {
      if (item.is_complementary) return;
      const taxRate = Number(String(item.tax_rate || 0).replace(/,/g, "")) || 0;
      const itemPrice = Number(String(item.price || 0).replace(/,/g, "")) * Number(String(item.quantity || 1).replace(/,/g, ""));
      let itemBase = itemPrice;
      if (item.tax_type === "inclusive") {
        itemBase = itemPrice / (1 + taxRate / 100);
      }
      const itemTaxable = itemBase - (itemBase * discountRatio) + (itemBase * scRatio);
      if (item.tax_type === "exclusive" || item.tax_type === "inclusive") {
        taxAmt += (itemTaxable * taxRate) / 100;
      }
    });

    const taxableAmt = Math.max(0, subTotal - effectiveDiscAmt + serviceChargeTotal);
    const loyalty = Number(state.loyaltyRedemptionAmount || 0);
    const beforeRound = Math.max(0, taxableAmt + taxAmt - loyalty);
    const roundOff = Number(state.roundOff || 0);
    const netPayable = Math.max(0, Number((beforeRound + roundOff).toFixed(2)));

    return {
      subTotal,
      discVal,
      discAmt: effectiveDiscAmt,
      discPercent,
      serviceChargeTotal,
      taxableAmt,
      taxAmt,
      loyalty,
      beforeRound,
      roundOff,
      netPayable
    };
  };

  const btnShowPayAndSendToKitchenModal = () => {
    if (cartItems?.length == 0) {
      toast.error(t('pos.empty_cart'));
      return;
    }

    const preparedCart = (cartItems || []).map(item => ({
      ...item,
      original_price: item.original_price !== undefined ? item.original_price : item.price
    }));

    setState(prev => ({
      ...prev,
      cartItems: preparedCart,
      roundOff: 0,
      targetTotal: undefined,
      paidAmount: undefined,
      tipAmount: 0,
      tipData: {
        distribution_type: prev.storeSettings?.tip_default_type || "direct",
        employee_id: user?.id || "",
        employee_name: user?.name || user?.username || "",
        pool_department: "Restaurant Service",
        notes: ""
      },
      cashTendered: 0,
      customerSearchResults: [],
      isCompletingPayment: false
    }));

    document.getElementById('modal-pay-and-send-kitchen-summary').showModal();
  };

  const handleCartItemPriceChange = (index, newPriceVal) => {
    const rawNum = parseFloat(String(newPriceVal)?.replace(/,/g, ""));
    const newPrice = isNaN(rawNum) ? 0 : Math.max(0, rawNum);

    setState(prev => {
      const updatedCart = [...(prev.cartItems || [])];
      if (updatedCart[index]) {
        if (updatedCart[index].original_price === undefined) {
          updatedCart[index].original_price = updatedCart[index].price;
        }
        updatedCart[index] = { ...updatedCart[index], price: newPrice };
      }
      return {
        ...prev,
        cartItems: updatedCart,
        targetTotal: undefined,
        paidAmount: undefined
      };
    });
  };

  const handleResetCartItemPrice = (index) => {
    setState(prev => {
      const updatedCart = [...(prev.cartItems || [])];
      if (updatedCart[index] && updatedCart[index].original_price !== undefined) {
        updatedCart[index] = { ...updatedCart[index], price: updatedCart[index].original_price };
      }
      return {
        ...prev,
        cartItems: updatedCart,
        targetTotal: undefined,
        paidAmount: undefined
      };
    });
  };

  const btnSearchCustomerInModal = async () => {
    const query = modalCustomerSearchRef.current?.value;
    if (!query) {
      toast.error(t('pos.please_provide_phone') || "Please provide phone or name");
      return;
    }
    try {
      toast.loading(t('pos.please_wait'));
      const resp = await searchCustomer(query);
      toast.dismiss();
      if (resp.status == 200) {
        const results = resp.data || [];
        if (results.length === 0) {
          toast.error("No customer found!");
          return;
        }
        if (results.length === 1) {
          await btnSelectCustomerFromResult(results[0]);
          if (modalCustomerSearchRef.current) modalCustomerSearchRef.current.value = "";
        } else {
          setState(prev => ({
            ...prev,
            customerSearchResults: results
          }));
        }
      }
    } catch (error) {
      toast.dismiss();
      const message = error?.response?.data?.message || t('pos.getting_issues') || "Error finding customer";
      toast.error(message);
    }
  };

  const btnSelectCustomerFromResult = async (cust) => {
    try {
      toast.loading(t('pos.please_wait'));
      let custLoyalty = null;
      try {
        if (cust?.phone) {
          custLoyalty = await getCustomerLoyalty(cust.phone);
        }
      } catch (e) {}
      toast.dismiss();
      setState(prev => ({
        ...prev,
        customer: cust,
        customerType: "CUSTOMER",
        customerLoyalty: custLoyalty,
        customerSearchResults: [],
        loyaltyRedemptionAmount: 0,
        loyaltyPointsRedeemed: 0,
        loyaltyItemsRedeemed: 0
      }));
      toast.success(`Customer Selected: ${cust.name}`);
    } catch (error) {
      toast.dismiss();
      setState(prev => ({
        ...prev,
        customer: cust,
        customerType: "CUSTOMER",
        customerLoyalty: null,
        customerSearchResults: []
      }));
      toast.success(`Customer Selected: ${cust.name}`);
    }
  };

  const btnClearModalCustomer = () => {
    setState(prev => ({
      ...prev,
      customer: null,
      customerType: "WALKIN",
      customerLoyalty: null,
      customerSearchResults: [],
      loyaltyRedemptionAmount: 0,
      loyaltyPointsRedeemed: 0,
      loyaltyItemsRedeemed: 0
    }));
  };

  const handleLoyaltyRedemption = (e) => {
    const value = parseFloat(String(String(e.target.value).replace(/,/g, "")).replace(/,/g, "")) || 0;
    const settings = state.loyaltySettings;
    const loyalty = state.customerLoyalty;

    if (!settings || !loyalty) return;

    if (settings.type === 'points') {
      const maxRedeemablePoints = loyalty.points_balance;
      const pointsToRedeem = Math.min(value, maxRedeemablePoints);
      const amountToRedeem = (pointsToRedeem * settings.point_value) / 100;

      setState(prev => ({
        ...prev,
        loyaltyPointsRedeemed: pointsToRedeem,
        loyaltyRedemptionAmount: amountToRedeem
      }));
    } else if (settings.type === 'item') {
      const itemsToRedeem = Math.min(value, Math.floor(loyalty.items_count / settings.threshold_count));
      setState(prev => ({
        ...prev,
        loyaltyItemsRedeemed: itemsToRedeem * settings.threshold_count,
      }));
    }
  };

  const addPaymentRow = () => {
    const { netPayable } = getModalCalculations();
    const tip = Math.max(0, parseFloat(state.tipAmount) || 0);
    const totalToPay = state.paidAmount === undefined ? (netPayable + tip) : state.paidAmount;
    const currentPaid = state.multiPayments.reduce((acc, p) => acc + parseFloat(String(p.amount || 0).replace(/,/g, "")), 0);
    const remaining = Math.max(0, parseFloat((totalToPay - currentPaid).toFixed(2)));

    const firstType = (paymentTypes || [])[0];
    setState(prev => ({
      ...prev,
      multiPayments: [
        ...prev.multiPayments,
        { payment_type_id: firstType?.id, amount: remaining, title: firstType?.title }
      ]
    }));
  };

  const removePaymentRow = (index) => {
    const newPayments = [...state.multiPayments];
    newPayments.splice(index, 1);
    setState(prev => ({ ...prev, multiPayments: newPayments }));
  };

  const handleMultiPaymentChange = (index, field, value) => {
    const newPayments = [...state.multiPayments];
    if (field === 'payment_type_id') {
      const type = (paymentTypes?.find ? paymentTypes : []).find(t => t.id == value);
      newPayments[index].payment_type_id = value;
      newPayments[index].title = type?.title;
    } else {
      newPayments[index][field] = value;
    }
    setState(prev => ({ ...prev, multiPayments: newPayments }));
  };

  const btnPrintEstimateFromModal = () => {
    try {
      if (!cartItems || cartItems.length === 0) {
        toast.error("No items in cart to print estimate!");
        return;
      }

      const { subTotal, discAmt, serviceChargeTotal, taxableAmt, taxAmt, roundOff, netPayable } = getModalCalculations();

      const deliveryType = diningOption || diningOptionRef.current?.value || "";
      const tableId = deliveryType === 'room' ? null : (selectedTable || tableRef.current?.value || null);
      const posRoomSource = deliveryType === 'room' ? (selectedRoom || roomRef.current?.value || null) : null;
      let posTableTitle = tableId ? `Table ${tableId}` : '';
      if (deliveryType === 'room') {
        posTableTitle = posRoomSource ? (posRoomSource.toLowerCase().startsWith('room') ? posRoomSource : `Room ${posRoomSource}`) : 'Room Order';
      } else if (storeTables) {
        const t = storeTables.find(tb => tb.id == tableId);
        if (t) posTableTitle = t.table_title || t.table_no;
      }

      const details = {
        cartItems: cartItems.map(i => ({
          ...i,
          price: i.price,
          title: i.title,
          quantity: i.quantity,
          variant: i.variant,
          addons: i.addons,
          addons_ids: Array.isArray(i.addons) ? i.addons.map(a => a.id || a) : []
        })),
        deliveryType,
        customerType: state.customerType,
        customer: state.customer,
        tableId,
        currency,
        storeSettings: state.storeSettings,
        printSettings: state.printSettings,
        table_title: posTableTitle,
        source: posRoomSource,
        room_name: posRoomSource,
        itemsTotal: subTotal,
        taxTotal: taxAmt,
        taxableAmount: taxableAmt,
        serviceChargeTotal,
        storedDiscount: discAmt,
        roundOff: roundOff,
        payableTotal: netPayable,
        paidAmount: 0,
        dueAmount: netPayable,
        isEstimate: true,
        is_estimate: true,
        paymentMethod: "ESTIMATE (UNSETTLED)",
        date: new Date(),
        created_at: new Date()
      };

      setDetailsForReceiptPrint(details);

      import('../helpers/PrinterHelper').then(({ printReceipt }) => {
        printReceipt({
          ...details,
          bill_format: 'estimate_bill',
          pageFormat: state.printSettings?.page_format || localStorage.getItem('page_format') || '80',
          page_format: state.printSettings?.page_format || localStorage.getItem('page_format') || '80'
        });
        toast.success("Printing Estimate Bill (कच्चा बिल)...", { icon: "🧾" });
      }).catch(err => {
        console.error("Failed to print estimate:", err);
        toast.error("Failed to trigger estimate print");
      });
    } catch (e) {
      console.error("Error in btnPrintEstimateFromModal:", e);
      toast.error("Failed to print estimate bill");
    }
  };

  const btnPayAndSendToKitchen = async () => {
    const isPrintReceipt = printReceiptRef.current ? printReceiptRef.current.checked : ((printSettings?.is_enable_print || state.printSettings?.is_enable_print) ? true : false);

    if (state.multiPayments.length === 0 && !state.selectedPaymentType) {
      return toast.error(t('orders.select_payment_method') || "Please select a payment method");
    }

    const { subTotal, discAmt, serviceChargeTotal, taxableAmt, taxAmt, roundOff, netPayable } = getModalCalculations();

    const tipAmount = Math.max(0, parseFloat(state.tipAmount) || 0);
    const total = netPayable;
    const totalPayableWithTip = Number((netPayable + tipAmount).toFixed(2));
    const paid = state.paidAmount === undefined ? totalPayableWithTip : Number(state.paidAmount);
    const isDue = paid < totalPayableWithTip;

    if (isDue && (!state.customer || state.customer.id === "WALKIN" || state.customerType === "WALKIN")) {
      return toast.error("Customer selection is compulsory for Due payments. Walk-in customers cannot have due amounts.");
    }

    if (state.multiPayments.length > 0) {
      const sum = state.multiPayments.reduce((acc, p) => acc + parseFloat(String(p.amount || 0).replace(/,/g, "")), 0);
      if (Math.abs(sum - paid) > 0.01) {
        return toast.error(`Total of split payments (${sum.toFixed(2)}) must equal the paid amount (${paid.toFixed(2)})`);
      }
    }

    if (state.isCompletingPayment) return;
    setState(prev => ({ ...prev, isCompletingPayment: true }));

    try {
      const deliveryType = diningOption || diningOptionRef.current?.value || "";
      const tableId = deliveryType === 'room' ? null : (selectedTable || tableRef.current?.value || null);
      const customerType = state.customer ? "CUSTOMER" : (state.customerType || "WALKIN");
      const customer = state.customer;
      const source = deliveryType === 'room' ? (selectedRoom || roomRef.current?.value || null) : null;

      const localPrintId = "pos_local_" + Date.now() + "_" + Math.random().toString(36).substr(2, 8);
      if (typeof window !== 'undefined') {
        window.__localPlacedOrderIds = window.__localPlacedOrderIds || new Set();
        window.__localPlacedOrderIds.add(localPrintId);
      }

      toast.loading(t('pos.please_wait'));
      const res = await createOrderAndInvoice(
        cartItems,
        deliveryType,
        customerType,
        customer?.phone || customer?.id || null,
        tableId,
        subTotal,
        taxAmt,
        serviceChargeTotal,
        total,
        state.selectedQrOrderItem,
        state.selectedPaymentType,
        discAmt,
        paid,
        state.loyaltyRedemptionAmount,
        state.loyaltyPointsRedeemed,
        state.loyaltyItemsRedeemed,
        state.multiPayments,
        source,
        roundOff,
        localPrintId,
        tipAmount,
        state.tipData
      );
      toast.dismiss();
      if (res.status == 200) {
        const data = res.data;
        if (data._isOffline) {
          toast.success("Order & bill saved offline! Will auto-sync when online.", { icon: "💾" });
        } else {
          toast.success(res.data.message || "Order & invoice created!");
        }
        document.getElementById("modal-pay-and-send-kitchen-summary").close();

        const page_format = printSettings?.page_format || null;
        const is_enable_print = isPrintReceipt ? 1 : (printSettings?.is_enable_print || 0);

        const paymentType = (paymentTypes?.find ? paymentTypes : []).find((v) => v.id == state.selectedPaymentType);
        let paymentMethodText = "";
        if (state.multiPayments.length > 0) {
          paymentMethodText = "SPLIT PAYMENT (" + state.multiPayments.map(p => `${p.title || 'Pay'}: ${p.amount}`).join(", ") + ")";
        } else if (paymentType) {
          paymentMethodText = paymentType.title;
        }

        const posRoomSource = deliveryType === 'room' ? (roomRef.current?.value || null) : null;
        let posTableTitle = tableId ? `Table ${tableId}` : '';
        if (deliveryType === 'room') {
          posTableTitle = posRoomSource ? (posRoomSource.toLowerCase().startsWith('room') ? posRoomSource : `Room ${posRoomSource}`) : 'Room Order';
        } else if (storeTables) {
          const t = storeTables.find(tb => tb.id == tableId);
          if (t) posTableTitle = t.table_title || t.table_no;
        }

        const receiptDetails = {
          cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
          table_title: posTableTitle,
          source: posRoomSource,
          room_name: posRoomSource,
          itemsTotal: subTotal,
          taxTotal: taxAmt,
          taxableAmount: taxableAmt,
          serviceChargeTotal: serviceChargeTotal,
          storedDiscount: discAmt,
          roundOff: roundOff,
          payableTotal: total,
          paidAmount: paid,
          dueAmount: Math.max(0, total - paid),
          tokenNo: data.tokenNo,
          orderId: data.orderId,
          invoiceId: data.invoiceId,
          invoice_id: data.invoiceId,
          billNo: data.invoiceId,
          invoiceNo: data.invoiceId,
          created_at: new Date(),
          date: new Date(),
          paymentMethod: paymentMethodText,
          paymentTypeDetails: paymentType,
          multiPayments: state.multiPayments,
          cashTendered: state.cashTendered,
          changeAmount: Math.max(0, (state.cashTendered || 0) - paid),
        };
        setDetailsForReceiptPrint(receiptDetails);

        lastPlacedOrderIdRef.current = data.orderId;
        if (typeof window !== 'undefined') {
          window.__lastLocalPlacedOrderId = data.orderId;
          window.__localPlacedOrderIds = window.__localPlacedOrderIds || new Set();
          window.__localPlacedOrderIds.add(String(data.orderId));
          window.__localPlacedOrderIds.add(Number(data.orderId));
          if (data.tokenNo) {
            window.__localPlacedOrderIds.add(`tok_${data.tokenNo}`);
          }
          window.__printedItemFingerprints = window.__printedItemFingerprints || new Set();
          (cartItems || []).forEach(ci => {
            const varId = ci.variant_id || ci.variantId || 0;
            const qty = ci.quantity || ci.qty || 1;
            const notes = ci.notes || '';
            const itemId = ci.id || ci.item_id;
            window.__printedItemFingerprints.add(`ord_${data.orderId}_it_${itemId}_v_${varId}_q_${qty}_n_${notes}`);
            if (data.tokenNo) {
              window.__printedItemFingerprints.add(`tok_${data.tokenNo}_it_${itemId}_v_${varId}_q_${qty}_n_${notes}`);
            }
          });
        }
        sendNewOrderEvent(data.tokenNo, data.orderId);

        let newQROrderItemCount = state.qrOrdersCount;
        let newQROrders = [];
        if (state.selectedQrOrderItem) {
          newQROrderItemCount -= 1;
          newQROrders = state?.qrOrders?.filter((item) => item.id != state.selectedQrOrderItem);
        }

        setState((prev) => ({
          ...prev,
          cartItems: [],
          tokenNo: data.tokenNo,
          orderId: data.orderId,
          selectedQrOrderItem: null,
          qrOrders: newQROrders,
          qrOrdersCount: newQROrderItemCount,
          selectedPaymentType: null,
          multiPayments: [],
          discount: 0,
          discountType: "fixed",
          roundOff: 0,
          targetTotal: undefined,
          paidAmount: undefined,
          cashTendered: 0,
          customerSearchResults: [],
          isCompletingPayment: false
        }));

        _initPOS();

        // Auto-print KOT per category for the kitchen
        const shouldAutoPrintKOT = is_enable_print || localStorage.getItem('kdsAutoPrint') !== 'false';
        if (shouldAutoPrintKOT) {
          const printerGroups = groupItemsByPrinter(cartItems, categories);
          printKOT(printerGroups, {
            tableId,
            table_title: posTableTitle,
            deliveryType,
            source: posRoomSource,
            room_name: posRoomSource,
            tokenNo: data.tokenNo,
            orderId: data.orderId,
            customerName: customer?.name,
            waiterName: user?.name || user?.username || user?.email || '',
            page_format: page_format || localStorage.getItem('page_format') || '80',
            pageFormat: page_format || localStorage.getItem('page_format') || '80'
          });
        }

        if (isPrintReceipt) {
          import('../helpers/PrinterHelper').then(({ printReceipt }) => {
            printReceipt({
              ...receiptDetails,
              printSettings,
              bill_format: printSettings?.bill_format || localStorage.getItem('bill_format') || 'retail_tax_invoice',
              pageFormat: printSettings?.page_format || localStorage.getItem('page_format') || '80',
              page_format: printSettings?.page_format || localStorage.getItem('page_format') || '80'
            });
          }).catch(err => console.error("Receipt print error:", err));
        }

        const is_print_token = printSettings?.print_token === 1 || printSettings?.print_token === true || printSettings?.print_token === "1";
        if (is_print_token && data.tokenNo) {
          import('../helpers/PrinterHelper').then(({ printToken }) => {
            printToken({
              ...receiptDetails,
              tokenNo: data.tokenNo,
              orderId: data.orderId,
              printSettings,
              storeSettings: state.storeSettings,
              pageFormat: printSettings?.page_format || localStorage.getItem('page_format') || '80',
              page_format: printSettings?.page_format || localStorage.getItem('page_format') || '80'
            });
          }).catch(err => console.error("Token print error:", err));
        }

        // show print token dialog
        document.getElementById("modal-print-token").showModal();
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.something_went_wrong');
      console.error(error);
      toast.dismiss();
      toast.error(message);
    } finally {
      setState(prev => ({ ...prev, isCompletingPayment: false }));
    }
  };

  const btnShowSendToKitchenModal = () => {
    // calculate the item - total, tax, incl. tax, excl. tax, tax total, payable total

    if (cartItems?.length == 0) {
      toast.error(t('pos.empty_cart'));
      return;
    }

    const { itemsTotal, taxTotal, serviceChargeTotal, payableTotal, discountAmount } = calculateOrderSummary();

    setState({
      ...state,
      itemsTotal,
      taxTotal,
      serviceChargeTotal,
      payableTotal,
      discount: discountAmount
    });
    document.getElementById('modal-send-kitchen-summary').showModal();
  }

  const btnSendToKitchen = async () => {
    try {
      const deliveryType = diningOption || diningOptionRef.current?.value || "";
      const tableId = deliveryType === 'room' ? null : (selectedTable || tableRef.current?.value || null);
      const customerType = state.customerType;
      const customer = state.customer;
      const source = deliveryType === 'room' ? (selectedRoom || roomRef.current?.value || null) : null;

      toast.loading(t('pos.please_wait'));

      // EDIT MODE: update the existing order
      if (state.editOrderId) {
        const res = await updateOrder(state.editOrderId, cartItems, deliveryType, customerType, customer, tableId, source);
        toast.dismiss();
        if (res.status === 200) {
          toast.success(`Order #${state.editOrderId} updated successfully!`);
          document.getElementById("modal-send-kitchen-summary").close();
          setState(prev => ({ ...prev, cartItems: [], editOrderId: null }));
          navigate('/dashboard/orders', { replace: true });
        }
        return;
      }

      // NORMAL MODE: create new order
      const localPrintId = "pos_local_" + Date.now() + "_" + Math.random().toString(36).substr(2, 8);
      if (typeof window !== 'undefined') {
        window.__localPlacedOrderIds = window.__localPlacedOrderIds || new Set();
        window.__localPlacedOrderIds.add(localPrintId);
      }

      const res = await createOrder(cartItems, deliveryType, customerType, customer, tableId, state.selectedQrOrderItem, source, localPrintId);
      toast.dismiss();
      if (res.status == 200) {
        const data = res.data;
        if (data._isOffline) {
          toast.success("KOT saved offline! Kitchen printing will proceed.", { icon: "💾" });
        } else {
          toast.success(res.data.message || "Order sent to kitchen!");
        }
        document.getElementById("modal-send-kitchen-summary").close();

        const page_format = printSettings?.page_format || null;
        const is_enable_print = printSettings?.is_enable_print || 0;

        const posRoomSource = deliveryType === 'room' ? (roomRef.current?.value || null) : null;
        let posTableTitle = tableId ? `Table ${tableId}` : '';
        if (deliveryType === 'room') {
          posTableTitle = posRoomSource ? (posRoomSource.toLowerCase().startsWith('room') ? posRoomSource : `Room ${posRoomSource}`) : 'Room Order';
        } else if (storeTables) {
          const t = storeTables.find(tb => tb.id == tableId);
          if (t) posTableTitle = t.table_title || t.table_no;
        }

        setDetailsForReceiptPrint({
          cartItems, deliveryType, customerType, customer, tableId, currency, storeSettings, printSettings,
          table_title: posTableTitle,
          source: posRoomSource,
          room_name: posRoomSource,
          itemsTotal: state.itemsTotal,
          taxTotal: state.taxTotal,
          serviceChargeTotal: state.serviceChargeTotal,
          payableTotal: state.payableTotal,
          tokenNo: data.tokenNo,
          orderId: data.orderId
        });

        lastPlacedOrderIdRef.current = data.orderId;
        if (typeof window !== 'undefined') {
          window.__lastLocalPlacedOrderId = data.orderId;
          window.__localPlacedOrderIds = window.__localPlacedOrderIds || new Set();
          window.__localPlacedOrderIds.add(String(data.orderId));
          window.__localPlacedOrderIds.add(Number(data.orderId));
          if (data.tokenNo) {
            window.__localPlacedOrderIds.add(`tok_${data.tokenNo}`);
          }
          window.__printedItemFingerprints = window.__printedItemFingerprints || new Set();
          (cartItems || []).forEach(ci => {
            const varId = ci.variant_id || ci.variantId || 0;
            const qty = ci.quantity || ci.qty || 1;
            const notes = ci.notes || '';
            const itemId = ci.id || ci.item_id;
            window.__printedItemFingerprints.add(`ord_${data.orderId}_it_${itemId}_v_${varId}_q_${qty}_n_${notes}`);
            if (data.tokenNo) {
              window.__printedItemFingerprints.add(`tok_${data.tokenNo}_it_${itemId}_v_${varId}_q_${qty}_n_${notes}`);
            }
          });
        }
        sendNewOrderEvent(data.tokenNo, data.orderId);

        let newQROrderItemCount = state.qrOrdersCount;
        let newQROrders = [];
        if (state.selectedQrOrderItem) {
          newQROrderItemCount -= 1;
          newQROrders = state?.qrOrders?.filter((item) => item.id != state.selectedQrOrderItem);
        }

        setState((prev) => ({
          ...prev,
          cartItems: [],
          tokenNo: data.tokenNo,
          orderId: data.orderId,
          selectedQrOrderItem: null,
          qrOrders: newQROrders,
          qrOrdersCount: newQROrderItemCount
        }))

        _initPOS()

        
        const shouldAutoPrintKOT = is_enable_print || localStorage.getItem('kdsAutoPrint') !== 'false';
        if(shouldAutoPrintKOT) {
          const printerGroups = groupItemsByPrinter(cartItems, categories);
          const page_format = printSettings?.page_format || localStorage.getItem('page_format') || '80';

          printKOT(printerGroups, {
            tableId,
            table_title: posTableTitle,
            deliveryType,
            source: posRoomSource,
            room_name: posRoomSource,
            tokenNo: data.tokenNo,
            orderId: data.orderId,
            customerName: customer?.name,
            waiterName: user?.name || user?.username || user?.email || '',
            page_format: page_format,
            pageFormat: page_format
          });
        }


        const is_print_token = printSettings?.print_token === 1 || printSettings?.print_token === true || printSettings?.print_token === "1";
        if (is_print_token && data.tokenNo) {
          import('../helpers/PrinterHelper').then(({ printToken }) => {
            printToken({
              tokenNo: data.tokenNo,
              orderId: data.orderId,
              customer: state.customer,
              deliveryType,
              table_title: posTableTitle,
              source: posRoomSource,
              room_name: posRoomSource,
              printSettings,
              storeSettings: state.storeSettings,
              pageFormat: page_format,
              page_format: page_format
            });
          }).catch(err => console.error("Token print error:", err));
        }

        // show print token dialog
        document.getElementById("modal-print-token").showModal();
      }
    } catch (error) {
      const message = error?.response?.data?.message || t('pos.something_went_wrong');
      console.error(error);

      toast.dismiss();
      toast.error(message);
    }
  };
  const btnPrintTokenOnly = () => {
    const deliveryType = diningOption || diningOptionRef.current?.value || "";
    const posRoomSource = deliveryType === 'room' ? (roomRef.current?.value || null) : null;
    let posTableTitle = '';
    const tableId = deliveryType === 'room' ? null : (selectedTable || tableRef.current?.value || null);
    if (deliveryType === 'room') {
      posTableTitle = posRoomSource ? (posRoomSource.toLowerCase().startsWith('room') ? posRoomSource : `Room ${posRoomSource}`) : 'Room Order';
    } else if (storeTables) {
      const t = storeTables.find(tb => tb.id == tableId);
      if (t) posTableTitle = t.table_title || t.table_no;
    }

    import('../helpers/PrinterHelper').then(({ printToken }) => {
      printToken({
        tokenNo: state.tokenNo,
        orderId: state.orderId,
        customer: state.customer,
        deliveryType,
        table_title: posTableTitle,
        source: posRoomSource,
        room_name: posRoomSource,
        printSettings,
        storeSettings: state.storeSettings,
        pageFormat: printSettings?.page_format || localStorage.getItem('page_format') || '80',
        page_format: printSettings?.page_format || localStorage.getItem('page_format') || '80'
      });
    }).catch(err => {
      console.error("Token print error:", err);
      toast.error("Failed to print token: " + err.message);
    });
  };
  // send to kitchen modal


  const setCustomer = (customer) => {

    if (customer) {
      setState({
        ...state,
        customer: { phone: customer.value, name: customer.label },
        customerType: "CUSTOMER"
      })
      document.getElementById("modal-search-customer").close()
    } else {
      btnClearSearchCustomer();
    }
  }

  const searchCustomersAsync = async (inputValue) => {
    try {
      if (inputValue) {
        const resp = await searchCustomer(inputValue);
        if (resp.status == 200) {
          return resp.data.map((data) => ({ label: `${data.name} - (${data.phone})`, value: data.phone }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  // search customer modal


  return (
    <Page className='px-4 py-3 flex flex-col min-h-0'>
      <div className="flex md:items-center justify-between flex-col md:flex-row gap-2">
        <h3>{t('pos.title')}</h3>
        <div className='flex flex-wrap items-center gap-4'>
          <button onClick={btnInitNewOrder} className="text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconPlus size={18} stroke={iconStroke} /> {t('pos.new_order')}
          </button>

          {/* QR Menu Orders */}
          <button
            onClick={btnShowQROrdersModal}
            className="relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconQrcode size={18} stroke={iconStroke} /> {t('pos.qr_menu_orders')}

            {state.qrOrdersCount > 0 && <div className='absolute -top-2 -right-2 w-4 h-4 rounded-full bg-red-500 text-white text-xs flex items-center justify-center'> {state.qrOrdersCount}
            </div>}
          </button>
          {/* QR Menu Orders */}

          <button onClick={btnOpenDraftsModal} className="relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconNotes size={18} stroke={iconStroke} /> {t('pos.drafts_list')}
          </button>

          <Link to="/dashboard/orders" className="relative text-sm rounded-lg border transition active:scale-95 hover:shadow-lg text-gray-500 px-2 py-1 flex items-center gap-1 text-restro-text bg-restro-gray border-restro-border-green hover:bg-restro-button-hover">
            <IconArmchair size={18} stroke={iconStroke} /> {t('pos.table_orders')}
          </Link>
        </div>
      </div>

      <div className='mt-4 md:h-[calc(100vh-136px)] flex flex-col-reverse md:flex-row gap-4'>

        {/* pos items */}
        <div className="h-full md:w-[70%] overflow-y-auto scrollbar-none border rounded-2xl border-restro-border-green">
          {/* categories, search, toggle View*/}
          <div className="bg-background flex gap-2 justify-between sticky top-0 w-full z-10 px-4 py-3 rounded-t-2xl">
            <div className="flex overflow-x-auto space-x-2 text-sm custom-scroll-wrapper scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
              <div className="flex overflow-x-auto space-x-2 text-sm scrollbar scrollbar-none custom-scroll-div-horizon-smooth">
                <button
                  className={`min-w-28 px-4 py-2 rounded-xl ${selectedCategory === "all" ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme === 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
                  onClick={() => {
                    setState({
                      ...state,
                      selectedCategory: 'all'
                    })
                  }}
                >
                  {t('pos.all')}
                </button>
                {categories.filter((category) => category && category.is_enabled !== false && category.is_enabled !== 0 && category.is_enabled !== '0').map((category, index) => (
                  <button
                    key={index}
                    className={`min-w-fit px-4 py-2 rounded-xl ${String(selectedCategory) === String(category.id) ? theme === 'black' ? 'bg-restro-green-dark-mode text-white' : 'bg-restro-green text-white' : theme === 'black' ? 'bg-restro-bg-seconday-dark-mode' : 'bg-gray-100 text-gray-600'}`}
                    onClick={() => {
                      setState({
                        ...state,
                        selectedCategory: category.id
                      })
                    }}
                  >
                    {category.title}
                  </button>
                ))}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <label className="flex items-center w-60 rounded-xl px-3 py-2 gap-2 bg-restro-gray border border-restro-border-green">
                <IconSearch size={18} stroke={iconStroke} />
                <input value={searchQuery} onChange={e => setState({ ...state, searchQuery: e.target.value })} type="search" placeholder={t('appbar.search_placeholder')} className='w-full bg-transparent outline-none' />
              </label>
              <button
                className={clsx(`px-3 py-2 rounded-xl`,
                  theme === "black" ? state.view === "compact" ? "text-restro-green bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : "text-gray-300 bg-restro-bg-seconday-dark-mode hover:bg-restro-bg-hover-dark-mode" : state.view === "compact" ? "text-restro-green bg-gray-100  hover:bg-gray-200" : "text-gray-400 bg-gray-100  hover:bg-gray-200"
                )}
                onClick={() => {
                  const newView = state.view === 'detailed' ? 'compact' : 'detailed';
                  setState((prev) => ({
                    ...prev,
                    view: newView
                  }));
                  sessionStorage.setItem('view', newView);
                }}>
                <IconLayout2 size={24} stroke={2} />
              </button>
            </div>
          </div>
          {/* categories, search */}


          {/* list */}
          <div className='flex-1 h-full pt-3'>
            {state.view == 'detailed' ?
              <POSMenuItemDetailedView
                menuItems={menuItems}
                selectedCategory={selectedCategory}
                categories={categories}
                searchQuery={searchQuery}
                currency={currency}
                stockSellingPolicy={state.storeSettings?.stock_selling_policy || state.storeSettings?.stockSellingPolicy || 'allow_negative'}
                btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
                addItemToCart={addItemToCart}
              /> :
              <POSMenuItemCompactView
                menuItems={menuItems}
                selectedCategory={selectedCategory}
                categories={categories}
                searchQuery={searchQuery}
                currency={currency}
                stockSellingPolicy={state.storeSettings?.stock_selling_policy || state.storeSettings?.stockSellingPolicy || 'allow_negative'}
                btnOpenVariantAndAddonModal={btnOpenVariantAndAddonModal}
                addItemToCart={addItemToCart}
              />
            }
          </div>
          {/* list */}


        </div>
        {/* pos items */}

        {/* cart */}
        <div className="flex flex-col h-full md:w-[30%] relative border rounded-2xl border-restro-border-green">

          <div className="sticky w-full px-4 py-3 border-b rounded-t-2xl border-restro-border-green">
            {/* search customer */}
            <div onClick={btnOpenSearchCustomerModal} className="flex items-center gap-2">
              <input value={customerType == "WALKIN" ? t('pos.walkin_customer') : `${customer?.name || 'Customer'}`} type="text" placeholder={t('pos.search_customer')} className="flex items-center gap-1 text-sm w-full px-4 py-2 transition active:scale-95 hover:shadow-lg border rounded-lg bg-restro-gray border-restro-border-green hover:bg-restro-button-hover outline-restro-border-green" />
              <button onClick={btnOpenSearchCustomerModal} className="flex items-center justify-center w-9 h-9 transition active:scale-95 rounded-lg hover:shadow-lg bg-restro-gray border border-restro-border-green hover:bg-restro-button-hover">
                <IconSearch size={18} stroke={iconStroke} />
              </button>
            </div>
            {/* search customer */}

            {/* delivery type */}
            <select
              ref={diningOptionRef}
              value={diningOption}
              onChange={(e) => setDiningOption(e.target.value)}
              className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green"
            >
              <option value="">{t('pos.select_dining_option')}</option>
              <option value="dinein">{t('pos.dinein')}</option>
              <option value="delivery">{t('pos.delivery')}</option>
              <option value="takeaway">{t('pos.takeaway')}</option>
              <option value="room">Room Service / Folio</option>
            </select>
            {/* delivery type */}

            {diningOption === "room" ? (
              <select
                ref={roomRef}
                value={selectedRoom}
                onChange={(e) => setSelectedRoom(e.target.value)}
                className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green font-medium"
              >
                <option value="">
                  {(!state.rooms || state.rooms.length === 0) ? "No Rooms Found" : "Select Room"}
                </option>
                {state.rooms?.map((room, index) => {
                  const isOccupied = !!room.active_booking_id;
                  return (
                    <option
                      value={room.name}
                      key={index}
                      className={isOccupied ? "font-bold text-restro-green" : "text-gray-700 dark:text-gray-300"}
                    >
                      Room {room.name} {isOccupied ? `(Occupied - ${room.occupant || "Guest"})` : "(Available)"}
                    </option>
                  );
                })}
              </select>
            ) : (
              <select
                ref={tableRef}
                value={selectedTable}
                onChange={(e) => setSelectedTable(e.target.value)}
                className="mt-3 text-sm w-full border rounded-lg px-4 py-2 justify-center bg-restro-gray border-restro-border-green hover:bg-restro-button-hover focus:outline-restro-border-green"
              >
                <option value="">{t('pos.select_table')}</option>
                {
                  storeTables.map((table, index) => {
                    return <option value={table.id} key={index}>{table.table_title} ({table.seating_capacity} {t('pos.person')}) - {table.floor}</option>
                  })
                }
              </select>
            )}
            {/* table/room selection */}
          </div>


          {/* items */}
          <div className='flex-1 flex flex-col gap-4 overflow-y-auto px-4 pb-36'>
            <div className="h-1"></div>
            {cartItems?.map((cartItem, i) => {
              const { quantity, notes, title, price, variant, addons } = cartItem;
              const itemTotal = price * quantity;
              return <div key={i} className="text-sm rounded-lg p-2 relative border border-restro-border-green">
                <p>#{i + 1} {title} x {quantity} {cartItem.is_complementary && <span className="badge badge-success badge-sm">{t('pos.complementary')}</span>}</p>
                <p className='mt-1'>{currency}{Number(String(String(price || 0).replace(/,/g, "")).replace(/,/g, "")).toFixed(2)} <span className='text-xs'>x {quantity}</span> <span className='font-bold'>= {currency}{(cartItem.is_complementary ? 0 : itemTotal).toFixed(2)}</span></p>
                {notes && <p className="mt-1 text-xs text-gray-400">
                  {t('pos.notes')}: {notes}
                </p>
                }

                {variant && <p className="mt-1 text-xs text-gray-400">{t('pos.variant')}: {variant.title}</p>}
                {(addons && addons?.length > 0) && <p className="mt-1 text-xs text-gray-400">{t('pos.addons')}: {addons?.map((addon) => (`${addon.title}`))?.join(", ")}</p>}

                <div className="flex items-center justify-between gap-2 w-full mt-4">
                  <div className='flex items-center gap-1.5'>
                    <button onClick={() => {
                      minusCartItemQuantity(i, Number(quantity) || 1);
                    }} className="btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover shrink-0">
                      <IconMinus stroke={iconStroke} size={16} />
                    </button>
                    <input
                      type="number"
                      min="1"
                      className="w-16 h-7 text-center font-bold text-sm bg-white dark:bg-neutral-800 border border-restro-border-green rounded-lg focus:ring-2 focus:ring-restro-green/40 outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none transition px-1"
                      value={quantity}
                      onChange={(e) => updateDirectCartItemQuantity(i, e.target.value)}
                      onBlur={(e) => {
                        const val = parseInt(e.target.value, 10);
                        if (isNaN(val) || val < 1) {
                          updateDirectCartItemQuantity(i, 1);
                        }
                      }}
                      title="Directly enter item quantity (e.g. 100, 1000)"
                    />
                    <button onClick={() => {
                      addCartItemQuantity(i, Number(quantity) || 1);
                    }} className="btn btn-square btn-xs rounded-md bg-restro-gray hover:bg-restro-button-hover shrink-0">
                      <IconPlus stroke={iconStroke} size={16} />
                    </button>
                  </div>
                  <div className='flex items-center gap-1'>
                    <button onClick={() => { btnOpenNotesModal(i, notes) }} className="flex items-center text-sm transition active:scale-95 hover:shadow-lg  px-2 py-1 gap-1 rounded-lg border border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
                      <div><IconNote size={18} stroke={iconStroke} /></div> <p>{t('pos.add_notes')}</p>
                    </button>
                    <button onClick={() => {
                      const newCartItems = [...cartItems];
                      newCartItems[i].is_complementary = !newCartItems[i].is_complementary;
                      setState({ ...state, cartItems: newCartItems });
                    }} className={`flex items-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-1 gap-1 rounded-lg border border-restro-border-green ${cartItem.is_complementary ? 'bg-restro-green text-white' : 'bg-restro-gray hover:bg-restro-button-hover'}`}>
                      <IconGift size={18} stroke={iconStroke} />
                    </button>
                  </div>
                </div>

                {/* action btn delete */}
                <button onClick={() => {
                  removeItemFromCart(i);
                }} className="flex items-center justify-center absolute right-2 top-2 text-restro-red rounded-full w-6 h-6 transition bg-restro-gray hover:bg-restro-button-hover ">
                  <IconTrash stroke={iconStroke} size={14} />
                </button>
                {/* action btn delete */}
              </div>
            })}
          </div>
          {/* items */}



          {/* actions */}
          <div className="absolute w-full bottom-0 pb-4 rounded-b-2xl px-4 backdrop-blur border border-t border-b-0 border-l-0 border-r-0 border-restro-border-green">
            <div className="flex items-center flex-col lg:flex-row gap-2 mt-4">
              <button onClick={btnOpenSaveDraftModal} className="flex items-center flex-1 lg:flex-none text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
                <IconDeviceFloppy size={18} stroke={iconStroke} /> {t('pos.draft')}
              </button>

              <button onClick={btnShowSendToKitchenModal} className="flex-1 flex justify-center items-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2  gap-1 text-restro-text border rounded-lg border-restro-border-green bg-restro-gray hover:bg-restro-button-hover">
                <div><IconChefHat size={18} stroke={iconStroke} /></div> <p>{t('pos.send_to_kitchen')}</p>
              </button>
            </div>
            <div className="mt-2">
              <button onClick={btnShowPayAndSendToKitchenModal} className="flex items-center justify-center text-sm transition active:scale-95 hover:shadow-lg px-2 py-2 w-full gap-1 text-white border rounded-lg border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover">
                <div><IconCash size={18} stroke={iconStroke} /></div> <p>{t('pos.create_receipt_pay')}</p>
              </button>
            </div>
          </div>
          {/* actions */}

        </div>
        {/* cart */}

      </div>


      {/* dialog: notes */}
      <dialog id="modal-notes" className="modal modal-bottom sm:modal-middle">
        <div className="modal-box border border-restro-border-green dark:rounded-2xl">
          <div className='flex justify-between items-center'>
            <h3 className="font-bold text-lg">{t('pos.add_notes')}</h3>
            <button className="text-restro-red p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover" onClick={() => document.getElementById('modal-notes').close()}><IconX size={18} stroke={iconStroke} /></button>
          </div>

          <div className="my-4">
            <input type="hidden" ref={dialogNotesIndexRef} />
            <label htmlFor="dialogNotesText" className="mb-1 block text-gray-500 text-sm">{t('pos.notes')} <span className="text-xs text-gray-500">({t('pos.100_max_characters')})</span></label>
            <input ref={dialogNotesTextRef} type="text" name="dialogNotesText" id='dialogNotesText' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.notes_placeholder')} />
          </div>

          <div className="modal-action">
            <form method="dialog" className='w-full'>
              {/* if there is a button in form, it will close the modal */}
              <button onClick={() => { btnAddNotes(); }} className='rounded-xl transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: notes */}

      {/* dialog: category selection */}
      <dialog id="modal-categories" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <h3 className="font-bold text-lg">{t('pos.filters')}</h3>

          <div className="my-4">
            <label htmlFor="select_category" className='mb-1 text-sm w-full border rounded-lg px-2 py-2 block text-gray-500'>{t('pos.select_category')}</label>
            <select ref={categoryFilterDropdownRef} type="text" name="select_category" id='select_category' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.select_category')} >
              <option value="all">{t('pos.all')}</option>
              {
                categories.filter((category) => category.is_enabled).map((category, index) => <option value={category.id} key={index}>{category.title}</option>)
              }
            </select>
          </div>

          <div className="modal-action">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button onClick={() => { btnClearSelectedCategory() }} className="rounded-lg hover:bg-gray-200 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-gray-200 text-gray-500">{t('pos.close')}</button>
              <button onClick={() => { btnApplyCategoryFilter(); }} className="rounded-lg hover:bg-green-800 transition active:scale-95 hover:shadow-lg px-4 py-3 bg-restro-green text-white ml-3">{t('pos.apply')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: category selection */}

      {/* dialog: variants & addons */}
      <dialog id="modal-variants-addons" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <div className='flex justify-between items-center'>
            <h3 className="font-bold text-lg">{t('pos.select_variant_addons')}</h3>
            <button className='text-red-500 p-2 rounded-full bg-restro-button-hover' onClick={() => document.getElementById('modal-variants-addons').close()}><IconX size={18} stroke={iconStroke} /></button>
          </div>
          <div className="my-8 flex gap-2">
            <div className="flex-1">
              <h3>{t('pos.variants')}</h3>
              <div className="flex flex-col gap-2 mt-2">
                {
                  menuItems.find((item) => item.id == selectedItemId)?.variants?.map((variant, index) => {
                    const { id, item_id, title, price } = variant;

                    const fullItem = state.menuItems.find(item => item.id == selectedItemId);

                    const variantRecipeItems = fullItem.recipeItems?.filter(
                      r => r.variant_id === id && r.addon_id === 0
                    );

                    const isOutOfStock = variantRecipeItems?.length > 0 && variantRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, "")) < parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""))
                    );

                    const isLowStock = !isOutOfStock && variantRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
                    );

                    const quantitiesPossible = variantRecipeItems?.map(r => {
                      const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
                      const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
                      return Math.floor(currentQty / requiredQty);
                    });

                    const minItemsCanBeMade = quantitiesPossible?.length > 0
                      ? Math.min(...quantitiesPossible)
                      : null;

                    return (
                      <label key={index} className='cursor-pointer label justify-start gap-2'>
                        <input type="radio" className='radio' name="variants" id="" value={id} defaultChecked={index == 0} />
                        <div>
                          <span className="label-text">{title} - {currency}{price}</span>
                          {isOutOfStock ? (
                            <div className="mt-1 bg-red-100 text-red-700 text-[10px] font-bold px-1.5 py-[2px] z-10 w-full flex items-center justify-center gap-1 rounded-md">
                              <IconAlertTriangleFilled size={12} />
                              <span>{t('inventory.status_out_of_stock') || 'Out of Stock'}</span>
                            </div>
                          ) : isLowStock && (
                            <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
                              <div className="flex items-center gap-1">
                                <IconAlertTriangleFilled size={12} />
                                <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </label>
                    )
                  })
                }
              </div>
            </div>
            <div className="flex-1">
              <h3>{t('pos.addons')}</h3>
              <div className="flex flex-col gap-2 mt-2">
                {
                  state.menuItems.find((item) => item.id == selectedItemId)?.addons?.map((addon, index) => {
                    const { id, item_id, title, price } = addon;

                    const fullItem = menuItems.find(item => item.id == selectedItemId);

                    const addonRecipeItems = fullItem.recipeItems?.filter(
                      (r) => r.addon_id === id && r.variant_id === 0
                    );

                    const quantitiesPossible = addonRecipeItems?.map(r => {
                      const currentQty = parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, ""));
                      const requiredQty = parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""));
                      return Math.floor(currentQty / requiredQty);
                    });

                    const minItemsCanBeMade = quantitiesPossible?.length > 0
                      ? Math.min(...quantitiesPossible)
                      : null;

                    const isOutOfStock = addonRecipeItems?.length > 0 && addonRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity || "0").replace(/,/g, "")).replace(/,/g, "")) < parseFloat(String(String(r.recipe_quantity || "1").replace(/,/g, "")).replace(/,/g, ""))
                    );

                    const isLowStock = !isOutOfStock && addonRecipeItems?.some(
                      (r) => parseFloat(String(String(r.current_quantity).replace(/,/g, "")).replace(/,/g, "")) <= parseFloat(String(String(r.min_quantity_threshold).replace(/,/g, "")).replace(/,/g, ""))
                    );

                    return (
                      <label key={index} className='cursor-pointer label justify-start gap-2'>
                        <input type="checkbox" name="addons" id="" className='checkbox  checkbox-sm' value={id} />
                        <div>
                          <span className="label-text">{title} (+{currency}{price})</span>
                          {isOutOfStock ? (
                            <div className="mt-1 bg-red-100 text-red-700 text-[10px] font-bold px-1.5 py-[2px] z-10 w-full flex items-center justify-center gap-1 rounded-md">
                              <IconAlertTriangleFilled size={12} />
                              <span>{t('inventory.status_out_of_stock') || 'Out of Stock'}</span>
                            </div>
                          ) : isLowStock && (
                            <div className="mt-1 bg-yellow-100 text-yellow-800 text-[10px] font-medium px-1 py-[1px] z-10 w-full flex flex-col items-center gap-[2px] rounded-md">
                              <div className="flex items-center gap-1">
                                <IconAlertTriangleFilled size={12} />
                                <span>{t('inventory.low_stock')} - {minItemsCanBeMade} {t('inventory.qty')}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </label>
                    )
                  })
                }
              </div>
            </div>
          </div>

          <div className="modal-action">
            <form method="dialog" className="w-full flex gap-2">
              {/* if there is a button in form, it will close the modal */}
              <button onClick={() => { btnAddMenuItemToCartWithVariantsAndAddon() }} className='transition active:scale-95 hover:shadow-lg w-full px-4 py-3 text-white rounded-xl border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.add')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: variants & addons */}


      {/* dialog: save draft */}
      <dialog id="modal-save-draft" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <h3 className="font-bold text-lg">{t('pos.save_cart_items_to_drafts')}</h3>

          <div className="my-4">
            <label htmlFor="draftTitleRef" className="mb-1 block text-gray-500 text-sm">{t('pos.reference')}</label>
            <input ref={draftTitleRef} type="text" name="draftTitleRef" id='draftTitleRef' className='text-sm w-full rounded-lg px-4 py-2 border border-restro-border-green dark:bg-black focus:outline-restro-border-green' placeholder={t('pos.enter_reference_name')} />
          </div>

          <div className="modal-action">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
              <button onClick={() => { btnAddtoDrafts(); }} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.save')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: save draft */}

      {/* dialog: drafts list */}
      <dialog id="modal-drafts" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box p-0 border border-restro-border-green dark:rounded-2xl'>
          <div className='flex justify-between items-center sticky top-0 backdrop-blur px-6 py-4 bg-restro-gray'>
            <h3 className="font-bold text-lg">{t('pos.drafts')}</h3>
            <form method="dialog" className='flex gap-1'>
              {/* if there is a button in form, it will close the modal */}
              <button onClick={btnClearDrafts} className='transition active:scale-95 text-red-500 p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconClearAll stroke={iconStroke} /></button>
              <button className='transition active:scale-95 text-restro-text p-2 rounded-ful rounded-full w-9 h-9 flex items-center justify-center hover:bg-restro-button-hover'><IconX stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6 pt-4">
            {drafts.map((draftItem, index) => {
              const { nameRef, date, cart } = draftItem;

              return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border border-restro-border-green'>
                <div className='w-12 h-12 rounded-full flex items-center justify-center text-restro-text bg-restro-bg-gray'>
                  <IconClipboardList stroke={iconStroke} />
                </div>
                <div className='flex-1'>
                  <p>{t('pos.ref')}: {nameRef}</p>
                  <p className='text-xs'>{cart?.length} {t('pos.cart_items')}</p>
                  <p className='text-xs text-gray-500'>{date}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={() => { btnSelectDraftItemToCart(draftItem) }} className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

                  <button onClick={() => { btnDeleteDraftItem(index) }} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
                </div>
              </div>
            })}
          </div>


        </div>
      </dialog>
      {/* dialog: drafts list */}

      <DialogAddCustomer defaultValue={state.addCustomerDefaultValue} onSuccess={(phone, name) => {
        setCustomer({ value: phone, label: `${name} - (${phone})` });
        btnSelectCustomerFromResult({ phone, name });
        try { document.getElementById("modal-search-customer")?.close(); } catch(e) {}
      }} />

      {/* dialog: search customer */}
      <dialog id="modal-search-customer" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl h-96'>
          <div className="flex items-center justify-between">

            <h3 className="font-bold text-lg">{t('pos.search_customer')}</h3>
            <form method="dialog">
              <button onClick={btnClearSearchCustomer} className='btn btn-circle btn-sm text-restro-text border-none bg-restro-gray hover:bg-restro-button-hover'><IconRotate size={18} stroke={iconStroke} /></button>
              <button className='ml-2 btn btn-circle btn-sm text-red-500 border-none bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="my-4 flex items-end gap-2">
            <div className='flex-1'>
              <label htmlFor="searchCustomerRef" className="mb-1 block text-gray-500 text-sm">{t('pos.search_customer')}</label>
              {/* <input ref={searchCustomerRef} type="search" name="searchCustomerRef" id='searchCustomerRef' className="text-sm w-full border rounded-lg px-4 py-2 bg-gray-50 outline-restro-border-green-light" placeholder="Enter Customer Phone here..." /> */}
              <AsyncCreatableSelect
                menuPlacement='auto'
                loadOptions={searchCustomersAsync}
                isClearable
                noOptionsMessage={(v) => { return t('pos.type_to_find') }}
                onChange={(v) => {
                  setCustomer(v);
                }}
                onCreateOption={(inputValue) => {
                  setState({
                    ...state,
                    addCustomerDefaultValue: inputValue,
                  })
                  document.getElementById("modal-add-customer").showModal();
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: theme === "black" ? "" : "",
                    borderRadius: "0.5rem",
                    borderColor: theme === "black" ? "#232323" : "#f3f4f6",
                    height: 40,
                    boxShadow: "none",
                    color: theme === "black" ? "#ffffff" : "#111827", // text color
                    "&:hover": {
                      borderColor: theme === "black" ? "#23233" : "#9ca3af",
                    },
                  }),
                  menu: (base) => ({
                    ...base,
                    borderRadius: "0.5rem",
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: 150,
                    overflowY: "auto",
                    borderRadius: "0.5rem",
                    backgroundColor: theme === "black" ? "#232323" : "white",
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused
                      ? theme === "black"
                        ? "#292929"
                        : "#e5e7eb"
                      : theme === "black"
                        ? "#232323"
                        : "white",
                    color: theme === "black" ? "#f9fafb" : "#111827",
                    "&:active": {
                      backgroundColor: theme === "black" ? "#6b7280" : "#d1d5db",
                    },
                  }),
                  indicatorSeparator: (base) => ({
                    ...base,
                    backgroundColor: theme === "black" ? "#ffffff" : "#d1d5db", // divider color based on theme
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </dialog>
      {/* dialog: search customer */}

      {/* dialog: send to kitchen summary */}
      <dialog id="modal-send-kitchen-summary" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <div className="flex items-center justify-between gap-4">
            <h3 className="font-bold text-lg">{t('pos.send_order_to_kitchen')}</h3>
            <form method='dialog'>
              <button className='text-red-500 p-2 rounded-full bg-restro-gray hover:bg-restro-button-hover'><IconX size={18} stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="my-8 space-y-4 px-1">
            {[
              { label: t('pos.items_net_total'), value: state.itemsTotal },
              { label: t('pos.tax_total'), value: state.taxTotal, prefix: "+" },
              { label: t('pos.service_charge_total'), value: state.serviceChargeTotal, prefix: "+" },
            ].map(({ label, value, prefix = "" }, index) => (
              <div key={index} className='flex items-center justify-between text-restro-text'>
                <p>{label}</p>
                <p className="text-lg">
                  {prefix}{currency}{value.toFixed(2)}
                </p>
              </div>
            ))}

            <div className="flex items-center justify-between border-t border-gray-300 dark:border-restro-bg-gray pt-2 mt-2">
              <p className="text-xl font-medium">{t('pos.payable_total')}</p>
              <p className="text-xl font-bold text-restro-green">
                {currency}{state.payableTotal.toFixed(2)}
              </p>
            </div>
          </div>


          <div className="modal-action">
            <form method="dialog" className="w-full">
              {/* if there is a button in form, it will close the modal */}
              <button onClick={btnSendToKitchen} className='w-full rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.send_to_kitchen')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: send to kitchen summary */}

      {/* dialog: collect payment & send to kitchen summary */}
      <dialog id="modal-pay-and-send-kitchen-summary" className="modal">
        <div className="modal-box border border-gray-200 dark:border-zinc-800 rounded-2xl w-11/12 max-w-5xl bg-white dark:bg-zinc-950 p-0 overflow-hidden shadow-2xl">
          {/* Modal Header */}
          <div className="flex items-center justify-between px-6 py-4 bg-gray-50/80 dark:bg-zinc-900/90 border-b border-gray-200 dark:border-zinc-800">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-restro-green/10 dark:bg-restro-green/20 flex items-center justify-center text-restro-green shadow-sm">
                <IconReceipt size={22} />
              </div>
              <div>
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-extrabold text-lg text-gray-900 dark:text-white">
                    {t('pos.collect_payment_send_order_to_kitchen') || "Collect Payment & Settle Bill"}
                  </h3>
                  {(() => {
                    const posDelivery = diningOption || diningOptionRef.current?.value || "";
                    const posRoom = posDelivery === 'room' ? (selectedRoom || roomRef.current?.value || null) : null;
                    const posTable = posDelivery === 'room' ? null : (selectedTable || tableRef.current?.value || null);
                    let tableObj = null;
                    if (posTable && storeTables) {
                      tableObj = storeTables.find(tb => tb.id == posTable);
                    }
                    const tableTitle = tableObj ? (tableObj.table_title || tableObj.table_no) : posTable;

                    if (posRoom) {
                      return (
                        <span className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 flex items-center gap-1 border border-blue-200 dark:border-blue-800">
                          <IconBed size={13} /> Room {posRoom.replace(/^room\s*/i, '')}
                        </span>
                      );
                    }
                    if (tableTitle) {
                      return (
                        <span className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                          Table: {tableTitle}
                        </span>
                      );
                    }
                    if (posDelivery) {
                      return (
                        <span className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300 border border-amber-200 dark:border-amber-800 capitalize">
                          {posDelivery}
                        </span>
                      );
                    }
                    return null;
                  })()}
                </div>
                <p className="text-xs text-gray-400 dark:text-zinc-400">
                  Review & override item prices, apply discounts & round off, manage customer & dues, and complete settlement
                </p>
              </div>
            </div>
            <form method="dialog">
              <button className="btn btn-sm btn-circle text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-zinc-800 border-none transition">
                <IconX size={18} stroke={iconStroke} />
              </button>
            </form>
          </div>

          {/* Modal Body - 2 Columns */}
          <div className="p-6 max-h-[72vh] overflow-y-auto overscroll-contain bg-gray-50/50 dark:bg-zinc-950">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
              
              {/* LEFT COLUMN: Items list & Customer */}
              <div className="lg:col-span-7 space-y-5">
                
                {/* Section: Items & Price Overrides */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm overflow-hidden">
                  <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/60 dark:bg-zinc-950/60 flex items-center justify-between flex-wrap gap-2">
                    <div className="flex items-center gap-2">
                      <IconPencil size={18} className="text-amber-500" />
                      <div>
                        <h4 className="font-bold text-sm text-gray-900 dark:text-white">
                          Cart Items & Price Overrides ({cartItems?.length || 0})
                        </h4>
                        <p className="text-[11px] text-gray-400 dark:text-zinc-400">
                          Edit unit prices below. Changes dynamically recalculate taxes, discounts & bill total.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Room Linked Banner */}
                  {(() => {
                    const posDelivery = diningOption || diningOptionRef.current?.value || "";
                    const posRoom = posDelivery === 'room' ? (selectedRoom || roomRef.current?.value || null) : null;
                    if (posRoom) {
                      return (
                        <div className="mx-4 mt-3 p-2.5 rounded-xl bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-900/50 flex items-center gap-2 text-xs text-blue-800 dark:text-blue-300">
                          <IconBuildingSkyscraper size={16} className="text-blue-600 shrink-0" />
                          <span>
                            <strong>Room {posRoom} Linked:</strong> Settlement will finalize this room order and issue the receipt directly.
                          </span>
                        </div>
                      );
                    }
                    return null;
                  })()}

                  {/* Items List */}
                  <div className="p-3 space-y-2 max-h-[380px] overflow-y-auto">
                    {cartItems && cartItems.length > 0 ? (
                      cartItems.map((it, idx) => {
                        const itAddonsTotal = Array.isArray(it.addons)
                          ? it.addons.reduce((sum, a) => sum + Number(String(a?.price || 0).replace(/,/g, "")), 0)
                          : 0;
                        const itEffectiveUnitPrice = Number(it.price || 0);
                        const itLineTotal = itEffectiveUnitPrice * Number(it.quantity || 1);
                        const isModified = it.original_price !== undefined && Number(it.price) !== Number(it.original_price);
                        const itemTitle = it.title || it.item_title;
                        const variantTitle = it.variant?.title || it.variant_title;

                        return (
                          <div
                            key={idx}
                            className={`flex items-center justify-between p-3 rounded-xl border transition ${
                              isModified
                                ? "bg-amber-50/40 dark:bg-amber-950/20 border-amber-300 dark:border-amber-800/60 shadow-sm"
                                : "bg-gray-50/60 dark:bg-zinc-950/60 border-gray-150 dark:border-zinc-800/80 hover:border-gray-300 dark:hover:border-zinc-700"
                            }`}
                          >
                            {/* Item Info */}
                            <div className="flex-1 min-w-0 pr-3">
                              <div className="flex items-center gap-1.5 flex-wrap">
                                <span className="font-bold text-sm text-gray-900 dark:text-zinc-100 truncate">
                                  {itemTitle}
                                </span>
                                {variantTitle && (
                                  <span className="px-2 py-0.5 rounded text-[11px] font-semibold bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300 border border-emerald-200/50 dark:border-emerald-800/50">
                                    {variantTitle}
                                  </span>
                                )}
                                {it.is_complementary ? (
                                  <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">
                                    FREE
                                  </span>
                                ) : null}
                                {isModified && (
                                  <span className="px-1.5 py-0.2 text-[10px] font-extrabold uppercase rounded bg-amber-200 text-amber-900 dark:bg-amber-800/60 dark:text-amber-200">
                                    Edited
                                  </span>
                                )}
                              </div>
                              <div className="text-xs text-gray-500 dark:text-zinc-400 mt-1 flex items-center gap-2 flex-wrap">
                                <span className="font-bold text-gray-700 dark:text-zinc-300">
                                  Qty: {it.quantity}
                                </span>
                                {it.tax_rate > 0 && (
                                  <span className="text-[11px] text-gray-400">
                                    Tax: {it.tax_rate}% ({it.tax_type})
                                  </span>
                                )}
                                {Array.isArray(it.addons) && it.addons.length > 0 && (
                                  <span className="text-[11px] text-gray-400">
                                    + Addons: {it.addons.map(a => a?.title).filter(Boolean).join(", ")} ({currency}{itAddonsTotal.toFixed(2)})
                                  </span>
                                )}
                                {isModified && (
                                  <span className="text-[11px] text-gray-400 line-through">
                                    Orig: {currency}{Number(it.original_price).toFixed(2)}
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* Price Override Input & Total */}
                            <div className="flex items-center gap-2 shrink-0">
                              <div className="flex flex-col items-end">
                                <label className="text-[10px] uppercase font-bold text-gray-400 dark:text-zinc-500 tracking-wider">
                                  Unit Price
                                </label>
                                <div className="relative flex items-center">
                                  <span className="absolute left-2.5 text-xs text-gray-400 font-semibold pointer-events-none">
                                    {currency}
                                  </span>
                                  <input
                                    type="number"
                                    step="any"
                                    min="0"
                                    value={it.price}
                                    onChange={(e) => handleCartItemPriceChange(idx, e.target.value)}
                                    className="w-24 pl-7 pr-2 py-1.5 text-right font-extrabold text-sm bg-white dark:bg-zinc-900 border border-gray-300 dark:border-zinc-700 rounded-lg focus:ring-1 focus:ring-restro-green focus:border-restro-green outline-none shadow-sm transition"
                                    title="Click to edit unit price"
                                  />
                                </div>
                              </div>

                              {isModified && (
                                <button
                                  type="button"
                                  onClick={() => handleResetCartItemPrice(idx)}
                                  className="p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-950/30 transition mt-3"
                                  title="Reset to original price"
                                >
                                  <IconRotateClockwise size={15} />
                                </button>
                              )}

                              <div className="w-20 text-right mt-3">
                                <div className="text-[10px] uppercase font-bold text-gray-400 dark:text-zinc-500 tracking-wider">
                                  Line Total
                                </div>
                                <div className="text-sm font-black text-gray-900 dark:text-zinc-100">
                                  {currency}{(it.is_complementary ? 0 : itLineTotal).toFixed(2)}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p className="text-center py-6 text-sm text-gray-400">No items in cart</p>
                    )}
                  </div>
                </div>

                {/* Section: Customer & Loyalty */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm overflow-hidden">
                  <div className="p-4 border-b border-gray-100 dark:border-zinc-800 bg-gray-50/60 dark:bg-zinc-950/60 flex items-center gap-2">
                    <IconUser size={18} className="text-blue-500" />
                    <h4 className="font-semibold text-sm text-gray-900 dark:text-white">Customer & Loyalty</h4>
                  </div>
                  <div className="p-4 space-y-4">
                    <div className="flex flex-col gap-2">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-400">Select Customer</label>
                      {customer ? (
                        <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/20 p-3 rounded-xl border border-blue-100 dark:border-blue-900 animate-in zoom-in duration-200">
                          <div>
                            <p className="font-bold text-blue-700 dark:text-blue-300">{customer.name}</p>
                            <p className="text-xs text-blue-500 dark:text-blue-400">{customer.phone || customer.id}</p>
                          </div>
                          <button 
                            type="button"
                            onClick={btnClearModalCustomer}
                            className="btn btn-sm btn-circle btn-ghost text-red-500 hover:bg-red-100"
                            title="Remove Customer (Switch to Walk-in)"
                          >
                            <IconX size={16} />
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2">
                          <input 
                            ref={modalCustomerSearchRef}
                            type="text" 
                            placeholder="Search by phone or name..."
                            className="flex-1 p-2.5 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-sm focus:ring-1 focus:ring-restro-green focus:outline-none"
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                btnSearchCustomerInModal();
                              }
                            }}
                          />
                          <button 
                            type="button"
                            onClick={btnSearchCustomerInModal}
                            className="px-3.5 py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-zinc-800 dark:hover:bg-zinc-700 text-restro-text dark:text-white rounded-xl font-medium text-xs transition"
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              const val = modalCustomerSearchRef.current?.value || "";
                              setState(prev => ({ ...prev, addCustomerDefaultValue: val }));
                              document.getElementById("modal-add-customer").showModal();
                            }}
                            className="p-2.5 bg-restro-green hover:bg-restro-green-button-hover text-white rounded-xl font-medium transition flex items-center justify-center shadow-sm"
                            title="Add New Customer"
                          >
                            <IconPlus size={18} />
                          </button>
                        </div>
                      )}
                    </div>

                    {state.customerSearchResults?.length > 0 && !customer && (
                      <div className="border border-gray-200 dark:border-zinc-800 rounded-xl overflow-hidden shadow-sm max-h-40 overflow-y-auto">
                        <div className="p-2 border-b border-gray-100 dark:border-zinc-800 flex justify-between items-center bg-gray-50 dark:bg-zinc-950">
                          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-tighter">Search Results ({state.customerSearchResults.length})</p>
                          <button onClick={() => setState(prev => ({ ...prev, customerSearchResults: [] }))} className="text-gray-400 hover:text-red-500"><IconX size={12} /></button>
                        </div>
                        {state.customerSearchResults.map((res, i) => (
                          <button 
                            key={i}
                            type="button"
                            onClick={() => {
                              btnSelectCustomerFromResult(res);
                              if (modalCustomerSearchRef.current) modalCustomerSearchRef.current.value = "";
                            }}
                            className="w-full text-left px-3 py-2 hover:bg-blue-50 dark:hover:bg-blue-900/20 flex flex-col transition group border-b border-gray-50 dark:border-zinc-800 last:border-none"
                          >
                            <p className="font-bold text-sm group-hover:text-blue-600 transition">{res.name}</p>
                            <p className="text-xs text-gray-400">{res.phone}</p>
                          </button>
                        ))}
                      </div>
                    )}

                    {state.loyaltySettings && state.loyaltySettings.is_enabled && state.customerLoyalty && (
                      <div className="bg-amber-50 dark:bg-amber-900/10 p-3.5 rounded-xl border border-amber-200 dark:border-amber-800 space-y-2">
                        <div className="flex items-center justify-between">
                          <p className="text-xs font-semibold text-amber-800 dark:text-amber-300 uppercase tracking-wider flex items-center gap-1">
                            <IconGift size={14} /> Loyalty Rewards
                          </p>
                          <span className="badge badge-outline border-amber-300 text-amber-800 bg-white dark:bg-amber-900/20 text-xs">
                            {state.loyaltySettings.type === 'points' 
                              ? `${state.customerLoyalty.points_balance?.toFixed(2) || 0} Points`
                              : `${state.customerLoyalty.items_count || 0} Counted`
                            }
                          </span>
                        </div>

                        {state.loyaltySettings.type === 'points' ? (
                          <div className="flex items-center gap-2">
                            <input 
                              type="number" 
                              placeholder="Points to redeem"
                              value={state.loyaltyPointsRedeemed || ""}
                              onChange={handleLoyaltyRedemption}
                              max={state.customerLoyalty.points_balance}
                              className="w-32 p-2 rounded-lg border border-amber-200 dark:border-amber-700 bg-white dark:bg-amber-950 text-sm focus:outline-none focus:ring-1 ring-amber-400"
                            />
                            <button 
                              type="button"
                              onClick={() => {
                                handleLoyaltyRedemption({ target: { value: state.customerLoyalty.points_balance } });
                              }}
                              className="px-3 py-1.5 text-xs font-medium text-amber-700 bg-amber-100 rounded-lg hover:bg-amber-200 transition"
                            >
                              Max
                            </button>
                            {state.loyaltyRedemptionAmount > 0 && (
                              <span className="text-xs font-bold text-amber-700 dark:text-amber-400">
                                -{currency}{state.loyaltyRedemptionAmount.toFixed(2)} off
                              </span>
                            )}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* RIGHT COLUMN: Live Calculation, Discount, Round Off, Payments */}
              <div className="lg:col-span-5 space-y-5">
                
                {/* Section: Live Bill Summary Card */}
                {(() => {
                  const { subTotal, discVal, discAmt, discPercent, taxableAmt, taxAmt, serviceChargeTotal, loyalty, beforeRound, roundOff, netPayable } = getModalCalculations();

                  return (
                    <div className="bg-gradient-to-br from-white to-gray-50 dark:from-zinc-900 dark:to-zinc-950 rounded-2xl border border-gray-200 dark:border-zinc-800 p-5 shadow-sm space-y-4">
                      <div className="grid grid-cols-2 gap-4 pb-4 border-b border-gray-150 dark:border-zinc-800">
                        <div className="space-y-0.5">
                          <div className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">Sub-Total (Before Tax)</div>
                          <div className="text-xl font-bold text-gray-900 dark:text-zinc-200">{currency}{subTotal.toFixed(2)}</div>
                        </div>
                        <div className="space-y-0.5 text-right">
                          <div className="text-[10px] uppercase font-bold text-gray-400 tracking-wider">Net Payable</div>
                          <div className="text-2xl font-black text-restro-green">
                            {currency}{netPayable.toFixed(2)}
                          </div>
                        </div>
                      </div>
                      
                      {/* Detailed Breakdown */}
                      <div className="space-y-2 text-xs">
                        <div className="flex justify-between text-gray-600 dark:text-zinc-400 font-medium">
                          <span>Sub-Total (Before Tax)</span>
                          <span className="font-semibold text-gray-900 dark:text-zinc-200">{currency}{subTotal.toFixed(2)}</span>
                        </div>
                        {discAmt > 0 && (
                          <div className="flex justify-between items-center text-emerald-600 font-semibold">
                            <span>Discount {discPercent > 0 ? `(${discPercent}%)` : ''}:</span>
                            <span>-{currency}{discAmt.toFixed(2)}</span>
                          </div>
                        )}
                        <div className="flex justify-between text-gray-700 dark:text-zinc-300 font-semibold">
                          <span>Taxable Amount:</span>
                          <span>{currency}{taxableAmt.toFixed(2)}</span>
                        </div>
                        {taxAmt > 0 && (
                          <div className="flex justify-between text-gray-600 dark:text-zinc-400 font-medium">
                            <span>VAT / Taxes:</span>
                            <span className="font-semibold text-gray-900 dark:text-zinc-200">+{currency}{taxAmt.toFixed(2)}</span>
                          </div>
                        )}
                        {serviceChargeTotal > 0 && (
                          <div className="flex justify-between text-gray-600 dark:text-zinc-400 font-medium">
                            <span>Service Charge:</span>
                            <span className="font-semibold text-gray-900 dark:text-zinc-200">+{currency}{serviceChargeTotal.toFixed(2)}</span>
                          </div>
                        )}
                        
                        {/* Adjustments */}
                        {(loyalty > 0 || roundOff !== 0) && (
                          <div className="pt-2 border-t border-gray-150 dark:border-zinc-800 space-y-1.5">
                            {loyalty > 0 && (
                              <div className="flex justify-between items-center text-amber-600 font-semibold">
                                <span>Points Redemption:</span>
                                <span>-{currency}{loyalty.toFixed(2)}</span>
                              </div>
                            )}
                            {roundOff !== 0 && (
                              <div className="flex justify-between items-center text-blue-600 font-semibold">
                                <span>Round Off:</span>
                                <span>
                                  {roundOff > 0 ? `+${currency}${roundOff.toFixed(2)}` : `-${currency}${Math.abs(roundOff).toFixed(2)}`}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* Section: Additional Discount & Round Off */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm p-4 space-y-4">
                  {/* Discount */}
                  <div>
                    <div className="flex justify-between items-center mb-1.5">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-zinc-400 flex items-center gap-1.5">
                        <IconDiscount size={15} className="text-emerald-500" /> Apply Discount
                      </label>
                      <select 
                        value={state.discountType}
                        onChange={(e) => setState(prev => ({ ...prev, discountType: e.target.value, targetTotal: undefined }))}
                        className="text-xs font-bold bg-gray-100 dark:bg-zinc-800 rounded-lg px-2 py-1 outline-none text-gray-700 dark:text-zinc-200"
                      >
                        <option value="fixed">Fixed ({currency})</option>
                        <option value="percent">Percent (%)</option>
                      </select>
                    </div>
                    <input 
                      type="number" 
                      min="0"
                      value={state.discount || ""} 
                      onChange={(e) => {
                        const discount = parseFloat(String(e.target.value)?.replace(/,/g, "")) || 0;
                        setState(prev => ({ ...prev, discount, targetTotal: undefined }));
                      }} 
                      placeholder="0.00"
                      className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-sm font-semibold focus:ring-1 focus:ring-restro-green focus:outline-none"
                    />
                  </div>

                  {/* Round Off */}
                  <div className="pt-2 border-t border-gray-100 dark:border-zinc-800">
                    <div className="flex justify-between items-center mb-1.5">
                      <label className="text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-zinc-400 flex items-center gap-1.5">
                        <IconScale size={15} className="text-blue-500" /> Round Off
                      </label>
                      {Number(state.roundOff || 0) !== 0 && (
                        <span className="text-[11px] font-bold text-blue-600">
                          {Number(state.roundOff) > 0 ? `+${Number(state.roundOff).toFixed(2)}` : Number(state.roundOff).toFixed(2)}
                        </span>
                      )}
                    </div>
                    <div className="flex flex-wrap gap-1.5 mb-2">
                      {[
                        { label: "Floor 10", fn: (before) => Math.floor(before / 10) * 10 },
                        { label: "Nearest 10", fn: (before) => Math.round(before / 10) * 10 },
                        { label: "Floor 5", fn: (before) => Math.floor(before / 5) * 5 },
                        { label: "Nearest 1", fn: (before) => Math.round(before) },
                      ].map(preset => (
                        <button
                          key={preset.label}
                          type="button"
                          onClick={() => {
                            const { beforeRound } = getModalCalculations();
                            const target = preset.fn(beforeRound);
                            const diff = parseFloat((target - beforeRound).toFixed(2));
                            setState(prev => ({ ...prev, roundOff: diff, targetTotal: undefined, paidAmount: undefined }));
                          }}
                          className="px-2.5 py-1 bg-gray-100 hover:bg-blue-50 hover:text-blue-600 dark:bg-zinc-800 dark:hover:bg-zinc-700 rounded-lg text-[11px] font-bold transition text-gray-600 dark:text-zinc-300"
                        >
                          {preset.label}
                        </button>
                      ))}
                      <button
                        type="button"
                        onClick={() => setState(prev => ({ ...prev, roundOff: 0, targetTotal: undefined, paidAmount: undefined }))}
                        className="px-2.5 py-1 bg-gray-100 hover:bg-red-50 hover:text-red-600 dark:bg-zinc-800 rounded-lg text-[11px] font-bold transition text-gray-400"
                      >
                        Reset
                      </button>
                    </div>
                    <div className="grid grid-cols-2 gap-3 pt-1">
                      <div>
                        <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Round Off (+/-)</label>
                        <input
                          type="number"
                          step="any"
                          value={state.roundOff !== undefined && state.roundOff !== 0 ? state.roundOff : ""}
                          onChange={(e) => {
                            const val = e.target.value === "" ? 0 : parseFloat(e.target.value) || 0;
                            setState(prev => ({ ...prev, roundOff: val, targetTotal: undefined, paidAmount: undefined }));
                          }}
                          placeholder="0.00"
                          className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-xs font-semibold focus:ring-1 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                      <div>
                        <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Target Rounded Total</label>
                        <input
                          type="number"
                          step="any"
                          value={
                            state.targetTotal !== undefined
                              ? state.targetTotal
                              : (() => {
                                  const { netPayable } = getModalCalculations();
                                  return netPayable;
                                })()
                          }
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                              setState(prev => ({ ...prev, targetTotal: "", roundOff: 0, paidAmount: undefined }));
                              return;
                            }
                            const target = parseFloat(val);
                            if (!isNaN(target)) {
                              const { beforeRound } = getModalCalculations();
                              const diff = parseFloat((target - beforeRound).toFixed(2));
                              setState(prev => ({ ...prev, targetTotal: val, roundOff: diff, paidAmount: undefined }));
                            } else {
                              setState(prev => ({ ...prev, targetTotal: val }));
                            }
                          }}
                          onBlur={() => {
                            setState(prev => ({ ...prev, targetTotal: undefined }));
                          }}
                          placeholder="Target Bill"
                          className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-xs font-bold text-restro-green focus:ring-1 focus:ring-restro-green focus:outline-none"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Section: Optional Tip / Gratuity (Gated by SuperAdmin module & Store setting) */}
                {(() => {
                  const hasTipModule = (state.storeSettings?.enabled_modules || user?.enabled_modules || "").includes("tip_management");
                  const isTipAllowed = Boolean(hasTipModule && (state.storeSettings?.is_tip_enabled || state.storeSettings?.isTipEnabled));
                  if (!isTipAllowed) return null;

                  const { netPayable } = getModalCalculations();

                  return (
                    <TipInputCard
                      billTotal={netPayable}
                      tipAmount={state.tipAmount || 0}
                      onTipChange={(newTip) => {
                        setState((prev) => ({
                          ...prev,
                          tipAmount: newTip,
                          paidAmount: undefined,
                        }));
                      }}
                      tipData={state.tipData}
                      onTipDataChange={(newTipData) => {
                        setState((prev) => ({
                          ...prev,
                          tipData: newTipData,
                        }));
                      }}
                      storeSettings={state.storeSettings}
                      currency={currency}
                      defaultStaff={user}
                    />
                  );
                })()}

                {/* Section: Payments Selection */}
                <div className="bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-800 rounded-2xl shadow-sm p-4 space-y-4">
                  <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-zinc-800">
                    <div className="flex items-center gap-1.5">
                      <IconCreditCard size={17} className="text-indigo-500" />
                      <h4 className="font-bold text-xs uppercase tracking-wider text-gray-700 dark:text-zinc-300">
                        Payment Method
                      </h4>
                    </div>
                    <button 
                      type="button"
                      onClick={addPaymentRow}
                      className="text-xs font-bold text-indigo-600 hover:underline"
                    >
                      + Split Payment
                    </button>
                  </div>

                  {state.multiPayments.length > 0 ? (
                    <div className="space-y-2">
                      {state.multiPayments.map((payment, index) => (
                        <div key={index} className="flex gap-2 items-center bg-gray-50 dark:bg-zinc-950 p-2.5 rounded-xl border border-gray-150 dark:border-zinc-800">
                          <select 
                            value={payment.payment_type_id} 
                            onChange={(e) => handleMultiPaymentChange(index, 'payment_type_id', e.target.value)}
                            className="flex-1 bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700 rounded-lg px-2.5 py-1.5 text-xs outline-none focus:ring-1 ring-indigo-500"
                          >
                            {(paymentTypes || []).map(pt => (
                              <option key={pt.id} value={pt.id}>{pt.title}</option>
                            ))}
                          </select>
                          <div className="relative w-28">
                            <input 
                              type="number" 
                              value={payment.amount} 
                              onChange={(e) => handleMultiPaymentChange(index, 'amount', parseFloat(String(e.target.value)?.replace(/,/g, "")) || 0)}
                              className="w-full bg-white dark:bg-zinc-900 border border-gray-200 dark:border-zinc-700 rounded-lg pl-6 pr-2 py-1.5 text-xs font-bold outline-none focus:ring-1 ring-indigo-500"
                            />
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400 text-xs">{currency}</span>
                          </div>
                          <button 
                            type="button"
                            onClick={() => removePaymentRow(index)}
                            className="btn btn-xs btn-circle btn-ghost text-red-400 hover:text-red-600"
                          >
                            <IconTrash size={14} />
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                      {(paymentTypes || []).map((paymentType, i) => {
                        const uniqueId = `pos-pay-type-${paymentType?.id}`;
                        const isSelected = state.selectedPaymentType == paymentType?.id;
                        return (
                          <label key={i} className="block cursor-pointer">
                            <input
                              checked={isSelected}
                              onChange={() => setState(prev => ({ ...prev, selectedPaymentType: paymentType?.id }))}
                              type="radio" 
                              name="pos_payment_type" 
                              id={uniqueId} 
                              value={paymentType?.id} 
                              className="peer hidden" 
                            />
                            <div className="border border-gray-200 dark:border-zinc-800 dark:bg-zinc-950 bg-gray-50/80 rounded-xl flex items-center justify-center gap-1.5 flex-col px-2 py-3 peer-checked:border-restro-green peer-checked:bg-restro-green-light/10 peer-checked:text-restro-green transition shadow-xs text-center">
                              {paymentType?.icon && (
                                <div className={isSelected ? 'text-restro-green' : 'text-gray-400'}>
                                  {PAYMENT_ICONS[paymentType?.icon]}
                                </div>
                              )}
                              <p className="text-[11px] font-bold truncate max-w-full">{paymentType.title}</p>
                            </div>
                          </label>
                        );
                      })}
                    </div>
                  )}

                  {/* QR Display for selected payment type (Static / Dynamic Fonepay) */}
                  {state.selectedPaymentType && (paymentTypes || []).find(pt => pt.id == state.selectedPaymentType)?.qr_config && (
                    <div className="mt-3 p-4 bg-gray-50 dark:bg-zinc-950 border border-gray-200 dark:border-zinc-800 rounded-2xl flex flex-col items-center justify-center">
                      <p className="text-[11px] font-bold text-gray-500 mb-2 uppercase tracking-widest">Scan to Pay</p>
                      <PaymentQRDisplay 
                        paymentType={(paymentTypes || []).find(pt => pt.id == state.selectedPaymentType)}
                        amount={(() => {
                          const { netPayable } = getModalCalculations();
                          const tip = Math.max(0, parseFloat(state.tipAmount) || 0);
                          return state.paidAmount === undefined ? (netPayable + tip) : state.paidAmount;
                        })()}
                        orderId={state.activeOrderId}
                        onSuccess={btnPayAndSendToKitchen}
                      />
                    </div>
                  )}

                  {/* Cash Tendered & Change */}
                  <div className="grid grid-cols-2 gap-3 pt-2 border-t border-gray-100 dark:border-zinc-800">
                    <div>
                      <label className="text-[10px] font-bold uppercase tracking-wider text-gray-400 block mb-1">Cash Tendered</label>
                      <input 
                        type="number" 
                        value={state.cashTendered || ""} 
                        onChange={(e) => {
                          const cashTendered = parseFloat(String(e.target.value)?.replace(/,/g, "")) || 0;
                          setState(prev => ({ ...prev, cashTendered }));
                        }} 
                        placeholder="0.00"
                        className="w-full px-3 py-2 rounded-xl border border-gray-250 dark:border-zinc-800 bg-transparent text-sm font-semibold focus:ring-1 focus:ring-amber-500 focus:outline-none"
                      />
                    </div>
                    <div className="p-2.5 bg-gray-50 dark:bg-zinc-950 rounded-xl border border-gray-150 dark:border-zinc-800 flex flex-col justify-center">
                      <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400">Change Due</span>
                      <span className="font-extrabold text-blue-600 dark:text-blue-400 text-base">
                        {currency}{(() => {
                          const { netPayable } = getModalCalculations();
                          const tip = Math.max(0, parseFloat(state.tipAmount) || 0);
                          const paid = state.paidAmount === undefined ? (netPayable + tip) : state.paidAmount;
                          return Math.max(0, (state.cashTendered || 0) - paid).toFixed(2);
                        })()}
                      </span>
                    </div>
                  </div>

                  {/* Total Received Input */}
                  <div className="flex items-center justify-between bg-emerald-50 dark:bg-emerald-950/20 p-3 rounded-xl border border-emerald-200 dark:border-emerald-900/60">
                    <span className="text-xs font-bold text-emerald-800 dark:text-emerald-300 uppercase tracking-wider">Total Received</span>
                    <div className="flex items-center gap-1.5">
                      <span className="text-emerald-700 font-bold text-sm">{currency}</span>
                      <input 
                        type="number" 
                        value={(() => {
                          const { netPayable } = getModalCalculations();
                          const tip = Math.max(0, parseFloat(state.tipAmount) || 0);
                          return state.paidAmount === undefined ? (netPayable + tip) : state.paidAmount;
                        })()} 
                        onChange={(e) => {
                          const paidAmount = parseFloat(String(e.target.value)?.replace(/,/g, ""));
                          setState(prev => ({ ...prev, paidAmount }));
                        }} 
                        className="w-28 text-right bg-transparent border-b-2 border-emerald-400 dark:border-emerald-700 text-lg font-black text-emerald-700 dark:text-emerald-300 focus:outline-none focus:border-emerald-600"
                      />
                    </div>
                  </div>

                  {/* Due Balance Banner */}
                  {(() => {
                    const { netPayable } = getModalCalculations();
                    const tip = Math.max(0, parseFloat(state.tipAmount) || 0);
                    const totalRequired = Number((netPayable + tip).toFixed(2));
                    const paid = state.paidAmount === undefined ? totalRequired : Number(state.paidAmount || 0);
                    const due = Math.max(0, totalRequired - paid);
                    if (due > 0) {
                      return (
                        <div className="p-3 rounded-xl bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-800 text-xs text-amber-900 dark:text-amber-200">
                          <div className="flex items-center justify-between font-bold">
                            <span>Remaining Balance (Due):</span>
                            <span className="text-sm font-black text-amber-700 dark:text-amber-300">{currency}{due.toFixed(2)}</span>
                          </div>
                          <p className="text-[11px] mt-1 text-amber-700 dark:text-amber-400">
                            {!customer ? "⚠️ Customer selection required to record customer due balance." : `Will be recorded as unpaid due under ${customer.name}.`}
                          </p>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>

                {/* Print Receipt Option */}
                <label
                  htmlFor="print_receipt_pos_modal"
                  className="flex items-center justify-end gap-2.5 cursor-pointer py-1"
                >
                  <input
                    type="checkbox"
                    className="checkbox checkbox-primary rounded-lg checkbox-sm"
                    id="print_receipt_pos_modal"
                    ref={printReceiptRef}
                    defaultChecked={printSettings?.is_enable_print ? true : false}
                  />
                  <span className="text-xs font-semibold text-gray-700 dark:text-zinc-300">{t('orders.print_receipt_option') || 'Print Receipt after settlement'}</span>
                </label>

              </div>
            </div>
          </div>

          {/* Modal Footer Actions */}
          <div className="p-4 px-6 bg-gray-50 dark:bg-zinc-900 border-t border-gray-200 dark:border-zinc-800 flex flex-col sm:flex-row justify-between items-center gap-3">
            <button
              type="button"
              onClick={btnPrintEstimateFromModal}
              className="w-full sm:w-auto px-4 py-2.5 rounded-xl font-bold transition active:scale-95 border border-amber-300 bg-amber-50 hover:bg-amber-100 text-amber-900 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-800 flex items-center justify-center gap-2 text-xs shadow-xs"
              title="Print Estimate Bill (कच्चा बिल) with current prices and discount"
            >
              <SafeIconPrinter size={16} stroke={iconStroke} /> Print Estimate Bill (कच्चा बिल)
            </button>

            <button
              onClick={btnPayAndSendToKitchen}
              disabled={state.isCompletingPayment}
              className={`w-full sm:w-auto px-8 py-3 rounded-xl font-bold transition shadow-lg text-white flex items-center justify-center gap-2 text-sm ${
                state.isCompletingPayment ? "bg-gray-400 cursor-not-allowed" : "active:scale-95 bg-restro-green hover:bg-restro-green-button-hover"
              }`}
            >
              {state.isCompletingPayment ? (
                <>
                  <span className="loading loading-spinner loading-sm"></span> Processing...
                </>
              ) : (
                <>
                  <IconCheck size={18} /> {t('pos.collect_payment_send_to_kitchen') || 'Create Receipt & Pay'}
                </>
              )}
            </button>
          </div>
        </div>
      </dialog>
      {/* dialog: collect payment & send to kitchen summary */}

      {/* dialog: print-token */}
      <dialog id="modal-print-token" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl'>
          <h3 className="font-bold text-lg text-center">{t('pos.order_sent_to_kitchen')}</h3>

          <div className="my-8 mx-auto w-fit">
            <div className="flex items-center gap-2">
              <div className="w-12 h-12 flex items-center justify-center bg-restro-green text-white rounded-full">
                <IconCheck stroke={iconStroke} size={32} />
              </div>
              <p className="font-bold text-5xl">#{state?.tokenNo}</p>
            </div>

            <p className="text-sm mt-4 text-center">{t('pos.order_id')}: {state?.orderId}</p>
          </div>

          <div className="modal-action justify-center">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className='btn transition active:scale-95 hover:shadow-lg px-4 py-3 flex-1 items-center justify-center align-center rounded-xl border border-restro-border-green bg-restro-card-bg hover:bg-restro-button-hover text-restro-text'>{t('pos.close')}</button>
              <button onClick={btnPrintTokenOnly} className='rounded-xl transition active:scale-95 hover:shadow-lg px-4 py-3 text-white ml-3 border border-restro-border-green bg-restro-green hover:bg-restro-green-button-hover'>{t('pos.print_token')}</button>
            </form>
          </div>
        </div>
      </dialog>
      {/* dialog: print-token */}

      {/* dialog: qrorders */}
      <dialog id="modal-qrorders" className="modal modal-bottom sm:modal-middle">
        <div className='modal-box border border-restro-border-green dark:rounded-2xl p-0'>
          <div className="flex justify-between items-center sticky top-0 px-6 py-4">
            <h3 className="font-bold text-lg">{t('pos.qr_orders')}</h3>
            <form method="dialog" className='flex gap-2'>
              {/* if there is a button in form, it will close the modal */}
              <button onClick={btnClearQROrders} className="rounded-full hover:bg-red-200 transition active:scale-95 bg-red-50 dark:bg-red-500 dark:text-white text-red-500 w-9 h-9 flex items-center justify-center"><IconClearAll stroke={iconStroke} /></button>
              <button className="rounded-full hover:bg-gray-200 dark:hover:bg-black transition active:scale-95 bg-gray-100 dark:bg-restro-gray text-gray-500 dark:text-white w-9 h-9 flex items-center justify-center"><IconX stroke={iconStroke} /></button>
            </form>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-6 pb-6">
            {state?.qrOrders?.map((qrOrder, index) => {
              const { customer_type, customer_id, customer_name, table_id, table_title, items, id, source } = qrOrder;

              return <div key={index} className='flex items-center gap-1 rounded-2xl p-2 border dark:border-restro-gray'>
                <div className='w-12 h-12 rounded-full bg-gray-100 dark:bg-restro-gray dark:text-white text-gray-500 flex items-center justify-center'>
                  <IconClipboardList stroke={iconStroke} />
                </div>
                <div className='flex-1'>
                  <div className="flex items-center gap-1 text-xs text-gray-500">
                    {source ? <IconBed stroke={iconStroke} size={14} /> : <IconArmchair2 stroke={iconStroke} size={14} />}
                    <p className=''>{source || table_title || "N/A"}</p>
                  </div>
                  <div className="flex items-center gap-1 text-xs">
                    <IconUser stroke={iconStroke} size={14} />
                    <p className=''>{customer_type == "WALKIN" ? "WALKIN" : customer_name}</p>
                  </div>
                  <p className='text-xs'>{items?.length} {t('pos.cart_items')}</p>
                </div>
                <div className="flex flex-col gap-1">
                  <button onClick={() => { btnSelectQROrder(qrOrder) }} className='rounded-full transition active:scale-95 w-6 h-6 flex items-center justify-center text-restro-text bg-restro-gray hover:bg-restro-button-hover'><IconPencil size={14} stroke={iconStroke} /></button>

                  <button onClick={() => { btnCancelQROrder(id) }} className='rounded-full transition active:scale-95 text-red-500 w-6 h-6 flex items-center justify-center bg-restro-gray hover:bg-restro-button-hover'><IconTrash size={14} stroke={iconStroke} /></button>
                </div>
              </div>
            })}
          </div>
        </div>
      </dialog>
      {/* dialog: qrorders */}
    </Page>
  )
}
